var Fr = Object.defineProperty;
var qr = (t, e, a) => e in t ? Fr(t, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[e] = a;
var fe = (t, e, a) => (qr(t, typeof e != "symbol" ? e + "" : e, a), a);
import { jsx as b, jsxs as H } from "react/jsx-runtime";
import S, { createContext as Ve, Component as Ir, createElement as he, useRef as $r, useCallback as Yr, forwardRef as qa, useState as mr, Suspense as Br, useEffect as Xr } from "react";
import * as Vr from "@tanstack/react-query";
import { useSuspenseInfiniteQuery as Ur, dehydrate as Jr, hydrate as Qr, QueryClientProvider as Zr, QueryErrorResetBoundary as Gr, QueryClient as Kr } from "@tanstack/react-query";
import { I18nextProvider as en, useTranslation as tn } from "react-i18next";
import "i18next";
const an = Ve(null), Ze = {
  didCatch: !1,
  error: null
};
class rn extends Ir {
  constructor(e) {
    super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = Ze;
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  resetErrorBoundary() {
    const {
      error: e
    } = this.state;
    if (e !== null) {
      for (var a, r, n = arguments.length, o = new Array(n), i = 0; i < n; i++)
        o[i] = arguments[i];
      (a = (r = this.props).onReset) === null || a === void 0 || a.call(r, {
        args: o,
        reason: "imperative-api"
      }), this.setState(Ze);
    }
  }
  componentDidCatch(e, a) {
    var r, n;
    (r = (n = this.props).onError) === null || r === void 0 || r.call(n, e, a);
  }
  componentDidUpdate(e, a) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: n
    } = this.props;
    if (r && a.error !== null && nn(e.resetKeys, n)) {
      var o, i;
      (o = (i = this.props).onReset) === null || o === void 0 || o.call(i, {
        next: n,
        prev: e.resetKeys,
        reason: "keys"
      }), this.setState(Ze);
    }
  }
  render() {
    const {
      children: e,
      fallbackRender: a,
      FallbackComponent: r,
      fallback: n
    } = this.props, {
      didCatch: o,
      error: i
    } = this.state;
    let s = e;
    if (o) {
      const d = {
        error: i,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof a == "function")
        s = a(d);
      else if (r)
        s = he(r, d);
      else if (n !== void 0)
        s = n;
      else
        throw i;
    }
    return he(an.Provider, {
      value: {
        didCatch: o,
        error: i,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, s);
  }
}
function nn() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return t.length !== e.length || t.some((a, r) => !Object.is(a, e[r]));
}
var on = /* @__PURE__ */ Ve({}), fr = "id";
function sn(t) {
  return t === void 0 && (t = fr), (t ? t + "-" : "") + Math.random().toString(32).substr(2, 6);
}
var dn = /* @__PURE__ */ Ve(sn);
function ln(t) {
  var e = t.children, a = t.prefix, r = a === void 0 ? fr : a, n = $r(0), o = Yr(function(i) {
    return i === void 0 && (i = r), (i ? i + "-" : "") + ++n.current;
  }, [r]);
  return /* @__PURE__ */ he(dn.Provider, {
    value: o
  }, e);
}
function un(t) {
  var e = t.children, a = t.unstable_system;
  return /* @__PURE__ */ he(on.Provider, {
    value: a
  }, e);
}
var cn = {};
function mn(t) {
  var e = t.unstable_prefix, a = t.unstable_system, r = a === void 0 ? cn : a, n = t.children;
  return /* @__PURE__ */ he(ln, {
    prefix: e
  }, /* @__PURE__ */ he(un, {
    unstable_system: r
  }, n));
}
const fn = ({ children: t, i18nInstance: e }) => /* @__PURE__ */ b(en, { i18n: e, children: t }), hn = (t = "label") => {
  const e = Array.isArray(t) ? t : [t];
  return tn(e);
}, vn = () => {
  const { t } = hn("label");
  return /* @__PURE__ */ b("div", { "data-testid": "default-loading-fallback", children: t("CX_ERROR_LOADING_TEXT", { ns: "label" }) });
};
function X(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
const pn = "application/json", hr = "Content-Type", Ne = Symbol(), vr = Symbol();
function Ia(t = {}) {
  var e;
  const a = t instanceof Array ? Object.fromEntries(t) : t;
  return (e = Object.entries(a).find(([r]) => r.toLowerCase() === hr.toLowerCase())) === null || e === void 0 ? void 0 : e[1];
}
function $a(t) {
  return /^application\/.*json.*/.test(t);
}
const Pe = function(t, e, a = !1) {
  return Object.entries(e).reduce((r, [n, o]) => {
    const i = t[n];
    return Array.isArray(i) && Array.isArray(o) ? r[n] = a ? [...i, ...o] : o : typeof i == "object" && typeof o == "object" ? r[n] = Pe(i, o, a) : r[n] = o, r;
  }, { ...t });
}, We = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(t, e = !0, a = !1, ...r) {
    const n = this.polyfills[t] || (typeof self < "u" ? self[t] : null) || (typeof global < "u" ? global[t] : null);
    if (e && !n)
      throw new Error(t + " is not defined");
    return a && n ? new n(...r) : n;
  }
};
function gn(t, e = !1) {
  We.options = e ? t : Pe(We.options, t);
}
function yn(t, e = !1) {
  We.polyfills = e ? t : Pe(We.polyfills, t);
}
function bn(t) {
  We.errorType = t;
}
const Mn = (t) => (e) => t.reduceRight((a, r) => r(a), e) || e;
class pr extends Error {
}
const wn = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  t = t._addons.reduce((h, y) => y.beforeRequest && y.beforeRequest(h, t._options, e) || h, t);
  const { _url: a, _options: r, _config: n, _catchers: o, _resolvers: i, _middlewares: s, _addons: d } = t, l = new Map(o), u = Pe(n.options, r);
  let c = a;
  const p = Mn(s)((h, y) => (c = h, n.polyfill("fetch")(h, y)))(a, u), f = new Error(), m = p.catch((h) => {
    throw { [Ne]: h };
  }).then((h) => {
    var y;
    if (!h.ok) {
      const D = new pr();
      if (D.cause = f, D.stack = D.stack + `
CAUSE: ` + f.stack, D.response = h, D.status = h.status, D.url = c, h.type === "opaque")
        throw D;
      const R = n.errorType === "json" || ((y = h.headers.get("Content-Type")) === null || y === void 0 ? void 0 : y.split(";")[0]) === "application/json";
      return (n.errorType ? R ? h.text() : h[n.errorType]() : Promise.resolve(h.body)).then((Y) => {
        if (D.message = typeof Y == "string" ? Y : h.statusText, Y)
          if (R && typeof Y == "string") {
            D.text = Y;
            try {
              D.json = JSON.parse(Y);
            } catch {
            }
          } else
            D[n.errorType] = Y;
        throw D;
      });
    }
    return h;
  }), M = (h) => h.catch((y) => {
    const D = Object.prototype.hasOwnProperty.call(y, Ne), R = D ? y[Ne] : y, $ = (R == null ? void 0 : R.status) && l.get(R.status) || l.get(R == null ? void 0 : R.name) || D && l.has(Ne) && l.get(Ne);
    if ($)
      return $(R, t);
    const Y = l.get(vr);
    if (Y)
      return Y(R, t);
    throw R;
  }), g = (h) => (y) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ M(h ? m.then((D) => D && D[h]()).then((D) => y ? y(D) : D) : m.then((D) => y ? y(D) : D)), w = {
    _wretchReq: t,
    _fetchReq: p,
    _sharedState: e,
    res: g(null),
    json: g("json"),
    blob: g("blob"),
    formData: g("formData"),
    arrayBuffer: g("arrayBuffer"),
    text: g("text"),
    error(h, y) {
      return l.set(h, y), this;
    },
    badRequest(h) {
      return this.error(400, h);
    },
    unauthorized(h) {
      return this.error(401, h);
    },
    forbidden(h) {
      return this.error(403, h);
    },
    notFound(h) {
      return this.error(404, h);
    },
    timeout(h) {
      return this.error(408, h);
    },
    internalError(h) {
      return this.error(500, h);
    },
    fetchError(h) {
      return this.error(Ne, h);
    }
  }, x = d.reduce((h, y) => ({
    ...h,
    ...typeof y.resolver == "function" ? y.resolver(h) : y.resolver
  }), w);
  return i.reduce((h, y) => y(h, t), x);
}, _n = {
  _url: "",
  _options: {},
  _config: We,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(t) {
    return { ...this, _addons: [...this._addons, t], ...t.wretch };
  },
  errorType(t) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: t
      }
    };
  },
  polyfills(t, e = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: e ? t : Pe(this._config.polyfills, t)
      }
    };
  },
  url(t, e = !1) {
    if (e)
      return { ...this, _url: t };
    const a = this._url.split("?");
    return {
      ...this,
      _url: a.length > 1 ? a[0] + t + "?" + a[1] : this._url + t
    };
  },
  options(t, e = !1) {
    return { ...this, _options: e ? t : Pe(this._options, t) };
  },
  headers(t) {
    const e = t ? Array.isArray(t) ? Object.fromEntries(t) : "entries" in t ? Object.fromEntries(t.entries()) : t : {};
    return { ...this, _options: Pe(this._options, { headers: e }) };
  },
  accept(t) {
    return this.headers({ Accept: t });
  },
  content(t) {
    return this.headers({ [hr]: t });
  },
  auth(t) {
    return this.headers({ Authorization: t });
  },
  catcher(t, e) {
    const a = new Map(this._catchers);
    return a.set(t, e), { ...this, _catchers: a };
  },
  catcherFallback(t) {
    return this.catcher(vr, t);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(t, e = !1) {
    return { ...this, _resolvers: e ? [t] : [...this._resolvers, t] };
  },
  defer(t, e = !1) {
    return {
      ...this,
      _deferred: e ? [t] : [...this._deferred, t]
    };
  },
  middlewares(t, e = !1) {
    return {
      ...this,
      _middlewares: e ? t : [...this._middlewares, ...t]
    };
  },
  fetch(t = this._options.method, e = "", a = null) {
    let r = this.url(e).options({ method: t });
    const n = Ia(r._options.headers), o = this._config.polyfill("FormData", !1), i = typeof a == "object" && !(o && a instanceof o) && (!r._options.headers || !n || $a(n));
    return r = a ? i ? r.json(a, n) : r.body(a) : r, wn(r._deferred.reduce((s, d) => d(s, s._url, s._options), r));
  },
  get(t = "") {
    return this.fetch("GET", t);
  },
  delete(t = "") {
    return this.fetch("DELETE", t);
  },
  put(t, e = "") {
    return this.fetch("PUT", e, t);
  },
  post(t, e = "") {
    return this.fetch("POST", e, t);
  },
  patch(t, e = "") {
    return this.fetch("PATCH", e, t);
  },
  head(t = "") {
    return this.fetch("HEAD", t);
  },
  opts(t = "") {
    return this.fetch("OPTIONS", t);
  },
  body(t) {
    return { ...this, _options: { ...this._options, body: t } };
  },
  json(t, e) {
    const a = Ia(this._options.headers);
    return this.content(e || $a(a) && a || pn).body(JSON.stringify(t));
  }
};
function xe(t = "", e = {}) {
  return { ..._n, _url: t, _options: e };
}
xe.default = xe;
xe.options = gn;
xe.errorType = bn;
xe.polyfills = yn;
xe.WretchError = pr;
class Pn extends Error {
  constructor(a, r, n, o, i) {
    super(a);
    fe(this, "statusCode");
    fe(this, "endpoint");
    fe(this, "args");
    fe(this, "response");
    this.name = "ApiError", this.statusCode = r, this.endpoint = n, this.args = o, this.response = i;
  }
}
class Ra extends Pn {
  constructor(e, a, r, n) {
    super(`Client error ${e} occurred while fetching ${a}`, e, a, r, n), this.name = "Api4xxError";
  }
}
class xn extends Ra {
  constructor(e, a, r) {
    super(404, e, a, r), this.name = "Api404Error";
  }
}
class En extends Ra {
  constructor(e, a, r) {
    super(400, e, a, r), this.name = "Api400Error";
  }
}
class kn {
  constructor(e = {}) {
    fe(this, "logger");
    fe(this, "notFoundLogLevel");
    fe(this, "badRequestLogLevel");
    fe(this, "other4xxLogLevel");
    this.logger = e.logger, this.notFoundLogLevel = e.notFoundLogLevel || "info", this.badRequestLogLevel = e.badRequestLogLevel || "warn", this.other4xxLogLevel = e.other4xxLogLevel || "warn";
  }
  log(e, a, r) {
    this.logger && this.logger[e](a, r);
  }
  async handleApiError(e, a, r) {
    if (!(e instanceof Response))
      throw e;
    const { status: n } = e;
    if (n === 404) {
      const o = new xn(a, r, e);
      return this.log(this.notFoundLogLevel, o.message, {
        args: r,
        endpoint: a,
        statusCode: n
      }), null;
    }
    if (n === 400) {
      const o = new En(a, r, e);
      return this.log(this.badRequestLogLevel, o.message, {
        args: r,
        endpoint: a,
        statusCode: n
      }), null;
    }
    if (n >= 400 && n < 500) {
      const o = new Ra(n, a, r, e);
      return this.log(this.other4xxLogLevel, o.message, {
        args: r,
        endpoint: a,
        statusCode: n
      }), null;
    }
    throw e;
  }
}
const Cn = (t, e) => {
  const a = new kn(e);
  return t.catcher(404, async (r) => (await a.handleApiError(r.response, r.url), null)).catcher(400, async (r) => (await a.handleApiError(r.response, r.url), null)).catcher(401, async (r) => (await a.handleApiError(r.response, r.url), null)).catcher(403, async (r) => (await a.handleApiError(r.response, r.url), null)).catcherFallback(async (r) => {
    if (r.status >= 400 && r.status < 500)
      return await a.handleApiError(r.response, r.url), null;
    throw r;
  });
};
/*! js-cookie v3.0.8 | MIT */
function Ye(t) {
  for (var e = 1; e < arguments.length; e++) {
    var a = arguments[e];
    for (var r in a)
      r !== "__proto__" && (t[r] = a[r]);
  }
  return t;
}
var Dn = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function it(t, e) {
  function a(n, o, i) {
    if (!(typeof document > "u")) {
      i = Ye({}, e, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires && (i.expires = i.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var d in i)
        i[d] && (s += "; " + d, i[d] !== !0 && (s += "=" + i[d].split(";")[0]));
      return document.cookie = n + "=" + t.write(o, n) + s;
    }
  }
  function r(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], i = {}, s = 0; s < o.length; s++) {
        var d = o[s].split("="), l = d.slice(1).join("=");
        try {
          var u = decodeURIComponent(d[0]);
          if (u in i || (i[u] = t.read(l, u)), n === u)
            break;
        } catch {
        }
      }
      return n ? i[n] : i;
    }
  }
  return Object.create(
    {
      set: a,
      get: r,
      remove: function(n, o) {
        a(
          n,
          "",
          Ye({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return it(this.converter, Ye({}, this.attributes, n));
      },
      withConverter: function(n) {
        return it(Ye({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
it(Dn, { path: "/" });
Ve(void 0);
const gr = (t) => {
  typeof window < "u" && (window.dataLayer = window.dataLayer || [], window.dataLayer.push({
    ...t
  }));
}, yr = {
  ARTICLE_CLICK: "article_click",
  HERO_ARTICLE_VIEW: "hero_article_view"
}, On = () => `${typeof window < "u" ? window.location.origin : ""}/api/cx`, br = (t, e) => {
  const a = new URL(t);
  return a.searchParams.set("fm", "webp"), a.searchParams.set("w", e.toString()), a.toString();
}, Nn = [
  // GTM/Google Debug
  "gtm_debug",
  "debug",
  // Cache bypass
  "nocache",
  // Google Ads/Analytics
  "gclid",
  "gclsrc",
  "_gl",
  // UTM Campaign Tracking
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id"
];
function He(t, e) {
  if (!e && typeof window > "u")
    return t;
  try {
    const a = new URL(e || window.location.href), r = new URLSearchParams(a.search), n = [];
    for (const s of Nn) {
      const d = r.get(s);
      d !== null && n.push([s, d]);
    }
    if (n.length === 0)
      return t;
    const o = t.startsWith("http://") || t.startsWith("https://"), i = o ? new URL(t) : new URL(t, a.origin);
    for (const [s, d] of n)
      i.searchParams.has(s) || i.searchParams.set(s, d);
    return o ? i.toString() : i.pathname + i.search + i.hash;
  } catch {
    return t;
  }
}
const Mr = async (t = On(), e, a) => {
  const { countryCode: r, limit: n, offset: o, repub: i, subdivision: s, topics: d, type: l } = e, u = new URL(`${t}/v2/articles`);
  return l && u.searchParams.append("articleType", l), n && u.searchParams.append("limit", n.toString()), o && u.searchParams.append("offset", o.toString()), d && u.searchParams.append("topics", d), Cn(
    xe(u.toString(), {
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        "country-code": r,
        repub: i,
        ...s ? { subdivision: s } : {},
        ...(a == null ? void 0 : a.nocache) && { "Cache-Control": "no-cache" }
      }
    }),
    a
  ).get().notFound(() => null).json();
}, wr = ({
  countryCode: t,
  limit: e,
  repub: a,
  subdivision: r,
  topics: n,
  type: o
}) => ["more-articles", a, t, r, n, o, e];
var Tn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Sn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function _r(t) {
  var e, a, r = "";
  if (typeof t == "string" || typeof t == "number")
    r += t;
  else if (typeof t == "object")
    if (Array.isArray(t)) {
      var n = t.length;
      for (e = 0; e < n; e++)
        t[e] && (a = _r(t[e])) && (r && (r += " "), r += a);
    } else
      for (a in t)
        t[a] && (r && (r += " "), r += a);
  return r;
}
function V() {
  for (var t, e, a = 0, r = "", n = arguments.length; a < n; a++)
    (t = arguments[a]) && (e = _r(t)) && (r && (r += " "), r += e);
  return r;
}
const Ya = (t) => typeof t == "boolean" ? `${t}` : t === 0 ? "0" : t, Ba = V, Wn = (t, e) => (a) => {
  var r;
  if ((e == null ? void 0 : e.variants) == null)
    return Ba(t, a == null ? void 0 : a.class, a == null ? void 0 : a.className);
  const { variants: n, defaultVariants: o } = e, i = Object.keys(n).map((l) => {
    const u = a == null ? void 0 : a[l], c = o == null ? void 0 : o[l];
    if (u === null)
      return null;
    const p = Ya(u) || Ya(c);
    return n[l][p];
  }), s = a && Object.entries(a).reduce((l, u) => {
    let [c, p] = u;
    return p === void 0 || (l[c] = p), l;
  }, {}), d = e == null || (r = e.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((l, u) => {
    let { class: c, className: p, ...f } = u;
    return Object.entries(f).every((m) => {
      let [M, g] = m;
      return Array.isArray(g) ? g.includes({
        ...o,
        ...s
      }[M]) : {
        ...o,
        ...s
      }[M] === g;
    }) ? [
      ...l,
      c,
      p
    ] : l;
  }, []);
  return Ba(t, i, d, a == null ? void 0 : a.class, a == null ? void 0 : a.className);
}, jn = "_icon_8pxtp_1", re = {
  icon: jn,
  "size--xs": "_size--xs_8pxtp_5",
  "size--s": "_size--s_8pxtp_10",
  "size--m": "_size--m_8pxtp_15",
  "size--l": "_size--l_8pxtp_20",
  "size--xl": "_size--xl_8pxtp_25",
  "size--xxl": "_size--xxl_8pxtp_30",
  "size--xxxl": "_size--xxxl_8pxtp_35",
  "color--black": "_color--black_8pxtp_40",
  "color--white": "_color--white_8pxtp_44",
  "color--green": "_color--green_8pxtp_48",
  "color--blue": "_color--blue_8pxtp_52",
  "color--grey": "_color--grey_8pxtp_56"
}, G = Wn(re.icon, {
  variants: {
    color: {
      black: re["color--black"],
      white: re["color--white"],
      blue: re["color--blue"],
      green: re["color--green"],
      grey: re["color--grey"]
    },
    size: {
      xs: re["size--xs"],
      s: re["size--s"],
      m: re["size--m"],
      l: re["size--l"],
      xl: re["size--xl"],
      xxl: re["size--xxl"],
      xxxl: re["size--xxxl"]
    }
  },
  defaultVariants: {
    color: "white",
    size: "m"
  }
}), zn = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ b("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 11, fill: "none", viewBox: "0 0 12 11", ref: o, ...n, children: /* @__PURE__ */ b(
      "path",
      {
        fill: "currentColor",
        d: "m.136 5.702 4.091 4.772c.178.249.546.248.773.045a.56.56 0 0 0 .045-.781L1.747 5.895h9.707c.301 0 .546-.251.546-.561s-.244-.561-.546-.561H1.747L5.045.93c.216-.215.156-.584-.071-.788s-.569-.189-.747.051L.136 4.965A.56.56 0 0 0 0 5.334c.01.119.059.279.136.368",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
zn.displayName = "Arrow";
const Ln = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ b("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 20, fill: "none", viewBox: "0 0 17 20", ref: o, ...n, children: /* @__PURE__ */ b(
      "path",
      {
        fill: "currentColor",
        d: "M16.5 1.838v14.999a.46.46 0 0 1-.248.413l-.18.046a.45.45 0 0 1-.316-.115l-1.735-1.631-.225.207v3.767a.46.46 0 0 1-.271.413l-.18.046a.45.45 0 0 1-.316-.115l-1.713-1.631-1.78 1.631a.443.443 0 0 1-.608 0l-1.78-1.631-1.78 1.631a.443.443 0 0 1-.608 0l-1.758-1.631-1.735 1.631a.44.44 0 0 1-.487.097.46.46 0 0 1-.279-.418V4.548c0-1.015.807-1.838 1.803-1.838h.901v-.873C3.204.823 4.011 0 5.007 0h9.69c.996 0 1.803.823 1.803 1.838m-4.868 15.458 1.262 1.195V4.525a.91.91 0 0 0-.901-.919h-9.69a.91.91 0 0 0-.901.919v13.966l1.284-1.195a.443.443 0 0 1 .608 0l1.78 1.631 1.78-1.631a.443.443 0 0 1 .608 0l1.78 1.631 1.78-1.631a.444.444 0 0 1 .609 0zm2.682-2.71 1.284 1.194-.023-13.943a.91.91 0 0 0-.901-.919h-9.69a.91.91 0 0 0-.901.919v.85h7.887c.996 0 1.803.823 1.803 1.838v9.992a.445.445 0 0 1 .541.069M4.976 8h3.048c.263 0 .476-.224.476-.5S8.287 7 8.024 7H4.976c-.263 0-.476.224-.476.5s.213.5.476.5m-.06 2h5.167c.23 0 .417.224.417.5s-.187.5-.417.5H4.917c-.23 0-.417-.224-.417-.5s.187-.5.417-.5zm0 3h5.167c.23 0 .417.224.417.5s-.187.5-.417.5H4.917c-.23 0-.417-.224-.417-.5s.187-.5.417-.5z",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
Ln.displayName = "Betslip";
const st = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ b("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 9, fill: "none", viewBox: "0 0 13 9", ref: o, ...n, children: /* @__PURE__ */ b(
      "path",
      {
        fill: "currentColor",
        d: "M6.455 5.188 10.781.86 12.22 2.3 6.455 8.062.691 2.3 2.13.86z",
        clipRule: "evenodd",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
st.displayName = "ChevronDown";
const Rn = S.forwardRef(
  ({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
    const i = V(
      G({
        color: t,
        size: e
      }),
      r
    ), s = {
      "--opacity": a
    };
    return S.cloneElement(
      /* @__PURE__ */ b("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ref: o, ...n, children: /* @__PURE__ */ H("g", { fill: "currentColor", children: [
        /* @__PURE__ */ b("path", { d: "M12 17.5a1 1 0 0 1-.707-.293l-9-9a1 1 0 1 1 1.414-1.414l9 9A1 1 0 0 1 12 17.5" }),
        /* @__PURE__ */ b("path", { d: "M12 17.5a1 1 0 0 1-.707-1.707l9-9a1 1 0 1 1 1.414 1.414l-9 9A1 1 0 0 1 12 17.5" })
      ] }) }),
      {
        role: "presentation",
        focusable: !1,
        className: i,
        "aria-hidden": !0,
        style: s,
        ...n
      }
    );
  }
);
Rn.displayName = "ChevronDownLight";
const An = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ b("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 8, fill: "none", viewBox: "0 0 13 8", ref: o, ...n, children: /* @__PURE__ */ b(
      "path",
      {
        fill: "currentColor",
        d: "M6.455 3.017 2.129 7.344.69 5.906 6.455.143l5.764 5.763-1.438 1.438z",
        clipRule: "evenodd",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
An.displayName = "ChevronUp";
const Hn = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ H("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 13, fill: "none", viewBox: "0 0 13 13", ref: o, ...n, children: [
      /* @__PURE__ */ b("path", { fill: "currentColor", d: "M1.638.33 12.75 11.48l-1.265 1.27L.373 1.6z" }),
      /* @__PURE__ */ b("path", { fill: "currentColor", d: "M.25 11.379 11.34.25l1.265 1.27-11.09 11.128z" })
    ] }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
Hn.displayName = "Cross";
const Fn = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ b("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: o, ...n, children: /* @__PURE__ */ b(
      "path",
      {
        fill: "currentColor",
        d: "M15.344 17.778a.75.75 0 0 0-.75-.75h-5.16a.75.75 0 1 0 0 1.5h5.16a.75.75 0 0 0 .75-.75m2.206-4a.75.75 0 0 0-.75-.75H7.204a.75.75 0 1 0 0 1.5H16.8a.75.75 0 0 0 .75-.75m2.45-4a.75.75 0 0 0-.75-.75H4.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 .75-.75m2-4a.75.75 0 0 0-.75-.75H2.75a.75.75 0 1 0 0 1.5h18.5a.75.75 0 0 0 .75-.75"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
Fn.displayName = "Filter";
const qn = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ b("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15, height: 15, fill: "none", viewBox: "0 0 15 15", ref: o, ...n, children: /* @__PURE__ */ b(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 13.5a6 6 0 0 0 4.243-1.757A6 6 0 0 0 13.5 7.5a6 6 0 0 0-1.757-4.243A6 6 0 0 0 7.5 1.5a6 6 0 0 0-6 6 6 6 0 0 0 6 6m0 1.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 1 1 0 15m-.75-8.25v4.5h1.5v-4.5zm0-3h1.5v1.5h-1.5z"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
qn.displayName = "Info";
const In = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ b("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "none", viewBox: "0 0 17 16", ref: o, ...n, children: /* @__PURE__ */ b(
      "path",
      {
        fill: "currentColor",
        d: "M1.423 0a.923.923 0 1 0 0 1.846h14.154a.923.923 0 1 0 0-1.846zM.5 7.692c0-.51.413-.923.923-.923h14.154a.923.923 0 1 1 0 1.846H1.423A.923.923 0 0 1 .5 7.692m0 6.769c0-.51.413-.923.923-.923h14.154a.923.923 0 1 1 0 1.846H1.423a.923.923 0 0 1-.923-.923",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
In.displayName = "Menu";
const $n = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ H(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 19,
        height: 18,
        fill: "currentColor",
        viewBox: "0 0 19 18",
        ref: o,
        ...n,
        children: [
          /* @__PURE__ */ b("path", { d: "m6.361 11.888.359-.84a.4.4 0 0 1 .229-.222.4.4 0 0 1 .125-.022q.098 0 .185.049c.546.306 1.279.49 1.961.49.801 0 1.383-.345 1.383-.818 0-.306-.169-.676-1.415-1.102-1.35-.446-2.725-1.097-2.725-2.557 0-1.108.767-1.975 2.052-2.317l.195-.052v-.916c0-.224.177-.408.39-.408h.923a.4.4 0 0 1 .39.408v.823l.229.03a4.6 4.6 0 0 1 1.482.432c.094.047.166.129.2.232s.031.216-.013.312l-.372.829a.39.39 0 0 1-.354.235.4.4 0 0 1-.161-.038c-.242-.118-.809-.388-1.714-.388-.822 0-1.188.334-1.188.667 0 .372.382.624 1.578 1.039 1.274.438 2.575 1.097 2.575 2.683 0 .856-.564 2.008-2.156 2.429l-.195.055v.949c0 .227-.177.41-.39.41h-.939a.4.4 0 0 1-.39-.41V13l-.231-.025c-.718-.085-1.394-.29-1.849-.566a.42.42 0 0 1-.163-.522z" }),
          /* @__PURE__ */ b(
            "path",
            {
              d: "M18.228 8.727a8.73 8.73 0 0 1-8.727 8.727A8.73 8.73 0 0 1 .773 8.727 8.73 8.73 0 0 1 9.501 0a8.73 8.73 0 0 1 8.727 8.727m-1.091 0c0 4.382-3.255 7.636-7.636 7.636s-7.636-3.255-7.636-7.636S5.12 1.091 9.501 1.091s7.636 3.255 7.636 7.636",
              fillRule: "evenodd"
            }
          )
        ]
      }
    ),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
$n.displayName = "Offers";
const Yn = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ H("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 20, fill: "none", viewBox: "0 0 17 20", ref: o, ...n, children: [
      /* @__PURE__ */ b(
        "path",
        {
          stroke: "currentColor",
          d: "M8.62 12v2.5M1 7.927v10.391h15.24V7.928zm2.77 0C3.77 3.771 3.77 1 8.62 1s4.85 2.77 4.85 6.927z"
        }
      ),
      /* @__PURE__ */ b("path", { stroke: "currentColor", d: "M8.62 12.855a.693.693 0 1 0 0-1.386.693.693 0 0 0 0 1.386Z" })
    ] }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
Yn.displayName = "Padlock";
const Bn = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ b("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 20, fill: "none", viewBox: "0 0 12 20", ref: o, ...n, children: /* @__PURE__ */ b("path", { stroke: "currentColor", d: "M4.9 11.119H1L8.8 1 6.85 8.738h3.9l-7.8 10.119z", strokeLinejoin: "round" }) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
Bn.displayName = "Picks";
const Xn = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ b("svg", { xmlns: "http://www.w3.org/2000/svg", width: 19, height: 19, fill: "none", viewBox: "0 0 19 19", ref: o, ...n, children: /* @__PURE__ */ b(
      "path",
      {
        fill: "currentColor",
        d: "M9.048.949a.5.5 0 0 1 .903 0l2.45 5.151a.5.5 0 0 0 .387.281l5.656.738a.5.5 0 0 1 .279.859L14.581 11.9a.5.5 0 0 0-.148.455l1.046 5.607a.5.5 0 0 1-.731.531l-5.009-2.727a.5.5 0 0 0-.478 0l-5.009 2.727a.5.5 0 0 1-.731-.531l1.046-5.607a.5.5 0 0 0-.148-.455L.277 7.978a.5.5 0 0 1 .279-.859l5.656-.738a.5.5 0 0 0 .387-.281z"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
Xn.displayName = "Star";
const Vn = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ b("svg", { xmlns: "http://www.w3.org/2000/svg", width: 22, height: 20, fill: "none", viewBox: "0 0 22 20", ref: o, ...n, children: /* @__PURE__ */ b(
      "path",
      {
        stroke: "currentColor",
        d: "M15.965 4.968c0 2.372-2.081 4.368-4.743 4.368S6.478 7.34 6.478 4.968 8.56.6 11.222.6s4.743 1.996 4.743 4.368ZM15.318 10.857c.174-.116.314-.182.435-.205 1.448-.273 2.575.594 3.49 2.15.906 1.543 1.472 3.573 1.799 5.122.16.758-.429 1.476-1.275 1.476H1.863c-.75 0-1.265-.556-1.207-1.185.222-2.425 1.23-6.34 5.288-7.684.275-.091.607-.059.935.095 1.852.867 3.42 1.291 4.805 1.31 1.4.02 2.577-.374 3.634-1.079Z",
        strokeWidth: 1.2
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
Vn.displayName = "Account";
const Un = S.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const i = V(
    G({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return S.cloneElement(
    /* @__PURE__ */ b(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12.78,
        height: 9.58,
        fill: "none",
        viewBox: "0 0 12.78 9.58",
        ref: o,
        ...n,
        children: /* @__PURE__ */ b("path", { fill: "currentColor", d: "m10.538 0 1.637 1.678-7.987 7.795-4.188-4L1.62 3.78l2.55 2.436z" })
      }
    ),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
Un.displayName = "Check";
var Pr = { exports: {} };
(function(t, e) {
  (function(a, r) {
    t.exports = r(S);
  })(Tn, (a) => (() => {
    var r = { 703: (s, d, l) => {
      var u = l(414);
      function c() {
      }
      function p() {
      }
      p.resetWarningCache = c, s.exports = function() {
        function f(g, w, x, h, y, D) {
          if (D !== u) {
            var R = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw R.name = "Invariant Violation", R;
          }
        }
        function m() {
          return f;
        }
        f.isRequired = f;
        var M = { array: f, bigint: f, bool: f, func: f, number: f, object: f, string: f, symbol: f, any: f, arrayOf: m, element: f, elementType: f, instanceOf: m, node: f, objectOf: m, oneOf: m, oneOfType: m, shape: m, exact: m, checkPropTypes: p, resetWarningCache: c };
        return M.PropTypes = M, M;
      };
    }, 697: (s, d, l) => {
      s.exports = l(703)();
    }, 414: (s) => {
      s.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, 98: (s) => {
      s.exports = a;
    } }, n = {};
    function o(s) {
      var d = n[s];
      if (d !== void 0)
        return d.exports;
      var l = n[s] = { exports: {} };
      return r[s](l, l.exports, o), l.exports;
    }
    o.n = (s) => {
      var d = s && s.__esModule ? () => s.default : () => s;
      return o.d(d, { a: d }), d;
    }, o.d = (s, d) => {
      for (var l in d)
        o.o(d, l) && !o.o(s, l) && Object.defineProperty(s, l, { enumerable: !0, get: d[l] });
    }, o.o = (s, d) => Object.prototype.hasOwnProperty.call(s, d), o.r = (s) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
    };
    var i = {};
    return (() => {
      o.r(i), o.d(i, { default: () => Je });
      var s = o(98), d = o.n(s), l = o(697), u = o.n(l);
      function c() {
        return c = Object.assign ? Object.assign.bind() : function(E) {
          for (var _ = 1; _ < arguments.length; _++) {
            var N = arguments[_];
            for (var T in N)
              Object.prototype.hasOwnProperty.call(N, T) && (E[T] = N[T]);
          }
          return E;
        }, c.apply(this, arguments);
      }
      var p = function(E) {
        var _ = E.pageClassName, N = E.pageLinkClassName, T = E.page, se = E.selected, B = E.activeClassName, ee = E.activeLinkClassName, P = E.getEventListener, v = E.pageSelectedHandler, j = E.href, C = E.extraAriaContext, O = E.pageLabelBuilder, W = E.rel, q = E.ariaLabel || "Page " + T + (C ? " " + C : ""), J = null;
        return se && (J = "page", q = E.ariaLabel || "Page " + T + " is your current page", _ = _ !== void 0 ? _ + " " + B : B, N !== void 0 ? ee !== void 0 && (N = N + " " + ee) : N = ee), d().createElement("li", { className: _ }, d().createElement("a", c({ rel: W, role: j ? void 0 : "button", className: N, href: j, tabIndex: se ? "-1" : "0", "aria-label": q, "aria-current": J, onKeyPress: v }, P(v)), O(T)));
      };
      p.propTypes = { pageSelectedHandler: u().func.isRequired, selected: u().bool.isRequired, pageClassName: u().string, pageLinkClassName: u().string, activeClassName: u().string, activeLinkClassName: u().string, extraAriaContext: u().string, href: u().string, ariaLabel: u().string, page: u().number.isRequired, getEventListener: u().func.isRequired, pageLabelBuilder: u().func.isRequired, rel: u().string };
      const f = p;
      function m() {
        return m = Object.assign ? Object.assign.bind() : function(E) {
          for (var _ = 1; _ < arguments.length; _++) {
            var N = arguments[_];
            for (var T in N)
              Object.prototype.hasOwnProperty.call(N, T) && (E[T] = N[T]);
          }
          return E;
        }, m.apply(this, arguments);
      }
      var M = function(E) {
        var _ = E.breakLabel, N = E.breakAriaLabel, T = E.breakClassName, se = E.breakLinkClassName, B = E.breakHandler, ee = E.getEventListener, P = T || "break";
        return d().createElement("li", { className: P }, d().createElement("a", m({ className: se, role: "button", tabIndex: "0", "aria-label": N, onKeyPress: B }, ee(B)), _));
      };
      M.propTypes = { breakLabel: u().oneOfType([u().string, u().node]), breakAriaLabel: u().string, breakClassName: u().string, breakLinkClassName: u().string, breakHandler: u().func.isRequired, getEventListener: u().func.isRequired };
      const g = M;
      function w(E) {
        var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        return E ?? _;
      }
      function x(E) {
        return x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
          return typeof _;
        } : function(_) {
          return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
        }, x(E);
      }
      function h() {
        return h = Object.assign ? Object.assign.bind() : function(E) {
          for (var _ = 1; _ < arguments.length; _++) {
            var N = arguments[_];
            for (var T in N)
              Object.prototype.hasOwnProperty.call(N, T) && (E[T] = N[T]);
          }
          return E;
        }, h.apply(this, arguments);
      }
      function y(E, _) {
        for (var N = 0; N < _.length; N++) {
          var T = _[N];
          T.enumerable = T.enumerable || !1, T.configurable = !0, "value" in T && (T.writable = !0), Object.defineProperty(E, T.key, T);
        }
      }
      function D(E, _) {
        return D = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(N, T) {
          return N.__proto__ = T, N;
        }, D(E, _);
      }
      function R(E, _) {
        if (_ && (x(_) === "object" || typeof _ == "function"))
          return _;
        if (_ !== void 0)
          throw new TypeError("Derived constructors may only return object or undefined");
        return $(E);
      }
      function $(E) {
        if (E === void 0)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return E;
      }
      function Y(E) {
        return Y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_) {
          return _.__proto__ || Object.getPrototypeOf(_);
        }, Y(E);
      }
      function F(E, _, N) {
        return _ in E ? Object.defineProperty(E, _, { value: N, enumerable: !0, configurable: !0, writable: !0 }) : E[_] = N, E;
      }
      var ze = function(E) {
        (function(P, v) {
          if (typeof v != "function" && v !== null)
            throw new TypeError("Super expression must either be null or a function");
          P.prototype = Object.create(v && v.prototype, { constructor: { value: P, writable: !0, configurable: !0 } }), Object.defineProperty(P, "prototype", { writable: !1 }), v && D(P, v);
        })(ee, E);
        var _, N, T, se, B = (T = ee, se = function() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
            return !1;
          if (typeof Proxy == "function")
            return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), !0;
          } catch {
            return !1;
          }
        }(), function() {
          var P, v = Y(T);
          if (se) {
            var j = Y(this).constructor;
            P = Reflect.construct(v, arguments, j);
          } else
            P = v.apply(this, arguments);
          return R(this, P);
        });
        function ee(P) {
          var v, j;
          return function(C, O) {
            if (!(C instanceof O))
              throw new TypeError("Cannot call a class as a function");
          }(this, ee), F($(v = B.call(this, P)), "handlePreviousPage", function(C) {
            var O = v.state.selected;
            v.handleClick(C, null, O > 0 ? O - 1 : void 0, { isPrevious: !0 });
          }), F($(v), "handleNextPage", function(C) {
            var O = v.state.selected, W = v.props.pageCount;
            v.handleClick(C, null, O < W - 1 ? O + 1 : void 0, { isNext: !0 });
          }), F($(v), "handlePageSelected", function(C, O) {
            if (v.state.selected === C)
              return v.callActiveCallback(C), void v.handleClick(O, null, void 0, { isActive: !0 });
            v.handleClick(O, null, C);
          }), F($(v), "handlePageChange", function(C) {
            v.state.selected !== C && (v.setState({ selected: C }), v.callCallback(C));
          }), F($(v), "getEventListener", function(C) {
            return F({}, v.props.eventListener, C);
          }), F($(v), "handleClick", function(C, O, W) {
            var q = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, J = q.isPrevious, le = J !== void 0 && J, Oe = q.isNext, Le = Oe !== void 0 && Oe, we = q.isBreak, oe = we !== void 0 && we, ve = q.isActive, pe = ve !== void 0 && ve;
            C.preventDefault ? C.preventDefault() : C.returnValue = !1;
            var ge = v.state.selected, A = v.props.onClick, ie = W;
            if (A) {
              var ae = A({ index: O, selected: ge, nextSelectedPage: W, event: C, isPrevious: le, isNext: Le, isBreak: oe, isActive: pe });
              if (ae === !1)
                return;
              Number.isInteger(ae) && (ie = ae);
            }
            ie !== void 0 && v.handlePageChange(ie);
          }), F($(v), "handleBreakClick", function(C, O) {
            var W = v.state.selected;
            v.handleClick(O, C, W < C ? v.getForwardJump() : v.getBackwardJump(), { isBreak: !0 });
          }), F($(v), "callCallback", function(C) {
            v.props.onPageChange !== void 0 && typeof v.props.onPageChange == "function" && v.props.onPageChange({ selected: C });
          }), F($(v), "callActiveCallback", function(C) {
            v.props.onPageActive !== void 0 && typeof v.props.onPageActive == "function" && v.props.onPageActive({ selected: C });
          }), F($(v), "getElementPageRel", function(C) {
            var O = v.state.selected, W = v.props, q = W.nextPageRel, J = W.prevPageRel, le = W.selectedPageRel;
            return O - 1 === C ? J : O === C ? le : O + 1 === C ? q : void 0;
          }), F($(v), "pagination", function() {
            var C = [], O = v.props, W = O.pageRangeDisplayed, q = O.pageCount, J = O.marginPagesDisplayed, le = O.breakLabel, Oe = O.breakClassName, Le = O.breakLinkClassName, we = O.breakAriaLabels, oe = v.state.selected;
            if (q <= W)
              for (var ve = 0; ve < q; ve++)
                C.push(v.getPageElement(ve));
            else {
              var pe = W / 2, ge = W - pe;
              oe > q - W / 2 ? pe = W - (ge = q - oe) : oe < W / 2 && (ge = W - (pe = oe));
              var A, ie, ae = function(ye) {
                return v.getPageElement(ye);
              }, I = [];
              for (A = 0; A < q; A++) {
                var Ie = A + 1;
                if (Ie <= J)
                  I.push({ type: "page", index: A, display: ae(A) });
                else if (Ie > q - J)
                  I.push({ type: "page", index: A, display: ae(A) });
                else if (A >= oe - pe && A <= oe + (oe === 0 && W > 1 ? ge - 1 : ge))
                  I.push({ type: "page", index: A, display: ae(A) });
                else if (le && I.length > 0 && I[I.length - 1].display !== ie && (W > 0 || J > 0)) {
                  var Qe = A < oe ? we.backward : we.forward;
                  ie = d().createElement(g, { key: A, breakAriaLabel: Qe, breakLabel: le, breakClassName: Oe, breakLinkClassName: Le, breakHandler: v.handleBreakClick.bind(null, A), getEventListener: v.getEventListener }), I.push({ type: "break", index: A, display: ie });
                }
              }
              I.forEach(function(ye, be) {
                var $e = ye;
                ye.type === "break" && I[be - 1] && I[be - 1].type === "page" && I[be + 1] && I[be + 1].type === "page" && I[be + 1].index - I[be - 1].index <= 2 && ($e = { type: "page", index: ye.index, display: ae(ye.index) }), C.push($e.display);
              });
            }
            return C;
          }), P.initialPage !== void 0 && P.forcePage !== void 0 && console.warn("(react-paginate): Both initialPage (".concat(P.initialPage, ") and forcePage (").concat(P.forcePage, ") props are provided, which is discouraged.") + ` Use exclusively forcePage prop for a controlled component.
See https://reactjs.org/docs/forms.html#controlled-components`), j = P.initialPage ? P.initialPage : P.forcePage ? P.forcePage : 0, v.state = { selected: j }, v;
        }
        return _ = ee, (N = [{ key: "componentDidMount", value: function() {
          var P = this.props, v = P.initialPage, j = P.disableInitialCallback, C = P.extraAriaContext, O = P.pageCount, W = P.forcePage;
          v === void 0 || j || this.callCallback(v), C && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(O) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(O, "). Did you forget a Math.ceil()?")), v !== void 0 && v > O - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(v, " > ").concat(O - 1, ").")), W !== void 0 && W > O - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(W, " > ").concat(O - 1, ")."));
        } }, { key: "componentDidUpdate", value: function(P) {
          this.props.forcePage !== void 0 && this.props.forcePage !== P.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({ selected: this.props.forcePage })), Number.isInteger(P.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
        } }, { key: "getForwardJump", value: function() {
          var P = this.state.selected, v = this.props, j = v.pageCount, C = P + v.pageRangeDisplayed;
          return C >= j ? j - 1 : C;
        } }, { key: "getBackwardJump", value: function() {
          var P = this.state.selected - this.props.pageRangeDisplayed;
          return P < 0 ? 0 : P;
        } }, { key: "getElementHref", value: function(P) {
          var v = this.props, j = v.hrefBuilder, C = v.pageCount, O = v.hrefAllControls;
          if (j)
            return O || P >= 0 && P < C ? j(P + 1, C, this.state.selected) : void 0;
        } }, { key: "ariaLabelBuilder", value: function(P) {
          var v = P === this.state.selected;
          if (this.props.ariaLabelBuilder && P >= 0 && P < this.props.pageCount) {
            var j = this.props.ariaLabelBuilder(P + 1, v);
            return this.props.extraAriaContext && !v && (j = j + " " + this.props.extraAriaContext), j;
          }
        } }, { key: "getPageElement", value: function(P) {
          var v = this.state.selected, j = this.props, C = j.pageClassName, O = j.pageLinkClassName, W = j.activeClassName, q = j.activeLinkClassName, J = j.extraAriaContext, le = j.pageLabelBuilder;
          return d().createElement(f, { key: P, pageSelectedHandler: this.handlePageSelected.bind(null, P), selected: v === P, rel: this.getElementPageRel(P), pageClassName: C, pageLinkClassName: O, activeClassName: W, activeLinkClassName: q, extraAriaContext: J, href: this.getElementHref(P), ariaLabel: this.ariaLabelBuilder(P), page: P + 1, pageLabelBuilder: le, getEventListener: this.getEventListener });
        } }, { key: "render", value: function() {
          var P = this.props.renderOnZeroPageCount;
          if (this.props.pageCount === 0 && P !== void 0)
            return P && P(this.props);
          var v = this.props, j = v.disabledClassName, C = v.disabledLinkClassName, O = v.pageCount, W = v.className, q = v.containerClassName, J = v.previousLabel, le = v.previousClassName, Oe = v.previousLinkClassName, Le = v.previousAriaLabel, we = v.prevRel, oe = v.nextLabel, ve = v.nextClassName, pe = v.nextLinkClassName, ge = v.nextAriaLabel, A = v.nextRel, ie = this.state.selected, ae = ie === 0, I = ie === O - 1, Ie = "".concat(w(le)).concat(ae ? " ".concat(w(j)) : ""), Qe = "".concat(w(ve)).concat(I ? " ".concat(w(j)) : ""), ye = "".concat(w(Oe)).concat(ae ? " ".concat(w(C)) : ""), be = "".concat(w(pe)).concat(I ? " ".concat(w(C)) : ""), $e = ae ? "true" : "false", Hr = I ? "true" : "false";
          return d().createElement("ul", { className: W || q, role: "navigation", "aria-label": "Pagination" }, d().createElement("li", { className: Ie }, d().createElement("a", h({ className: ye, href: this.getElementHref(ie - 1), tabIndex: ae ? "-1" : "0", role: "button", onKeyPress: this.handlePreviousPage, "aria-disabled": $e, "aria-label": Le, rel: we }, this.getEventListener(this.handlePreviousPage)), J)), this.pagination(), d().createElement("li", { className: Qe }, d().createElement("a", h({ className: be, href: this.getElementHref(ie + 1), tabIndex: I ? "-1" : "0", role: "button", onKeyPress: this.handleNextPage, "aria-disabled": Hr, "aria-label": ge, rel: A }, this.getEventListener(this.handleNextPage)), oe)));
        } }]) && y(_.prototype, N), Object.defineProperty(_, "prototype", { writable: !1 }), ee;
      }(s.Component);
      F(ze, "propTypes", { pageCount: u().number.isRequired, pageRangeDisplayed: u().number, marginPagesDisplayed: u().number, previousLabel: u().node, previousAriaLabel: u().string, prevPageRel: u().string, prevRel: u().string, nextLabel: u().node, nextAriaLabel: u().string, nextPageRel: u().string, nextRel: u().string, breakLabel: u().oneOfType([u().string, u().node]), breakAriaLabels: u().shape({ forward: u().string, backward: u().string }), hrefBuilder: u().func, hrefAllControls: u().bool, onPageChange: u().func, onPageActive: u().func, onClick: u().func, initialPage: u().number, forcePage: u().number, disableInitialCallback: u().bool, containerClassName: u().string, className: u().string, pageClassName: u().string, pageLinkClassName: u().string, pageLabelBuilder: u().func, activeClassName: u().string, activeLinkClassName: u().string, previousClassName: u().string, nextClassName: u().string, previousLinkClassName: u().string, nextLinkClassName: u().string, disabledClassName: u().string, disabledLinkClassName: u().string, breakClassName: u().string, breakLinkClassName: u().string, extraAriaContext: u().string, ariaLabelBuilder: u().func, eventListener: u().string, renderOnZeroPageCount: u().func, selectedPageRel: u().string }), F(ze, "defaultProps", { pageRangeDisplayed: 2, marginPagesDisplayed: 3, activeClassName: "selected", previousLabel: "Previous", previousClassName: "previous", previousAriaLabel: "Previous page", prevPageRel: "prev", prevRel: "prev", nextLabel: "Next", nextClassName: "next", nextAriaLabel: "Next page", nextPageRel: "next", nextRel: "next", breakLabel: "...", breakAriaLabels: { forward: "Jump forward", backward: "Jump backward" }, disabledClassName: "disabled", disableInitialCallback: !1, pageLabelBuilder: function(E) {
        return E;
      }, eventListener: "onClick", renderOnZeroPageCount: void 0, selectedPageRel: "canonical", hrefAllControls: !1 });
      const Je = ze;
    })(), i;
  })());
})(Pr);
var Jn = Pr.exports;
const Qn = /* @__PURE__ */ Sn(Jn), Zn = "_Pagination_1oamq_64", Gn = "_paginationContainer_1oamq_68", Kn = "_pageItem_1oamq_74", eo = "_pageItemDisabled_1oamq_96", to = "_active_1oamq_118", ao = "_breakEllipsis_1oamq_122", ro = "_previousIcon_1oamq_144", no = "_nextIcon_1oamq_148", oo = "_labelWrapper_1oamq_152", io = "_labelText_1oamq_158", Q = {
  Pagination: Zn,
  paginationContainer: Gn,
  pageItem: Kn,
  pageItemDisabled: eo,
  active: to,
  breakEllipsis: ao,
  previousIcon: ro,
  nextIcon: no,
  labelWrapper: oo,
  labelText: io
}, so = ({
  forcePage: t,
  pageCount: e,
  onPageChange: a,
  hrefBuilder: r,
  previousLabel: n,
  nextLabel: o,
  ...i
}) => {
  const s = typeof t == "number" ? t + 1 : 1, d = s === 1, l = s === e, u = d ? Q.pageItemDisabled : Q.pageItem, c = d ? "grey" : "black", p = l ? Q.pageItemDisabled : Q.pageItem, f = l ? "grey" : "black";
  return /* @__PURE__ */ b("div", { className: Q.Pagination, "data-testid": "pagination", children: /* @__PURE__ */ b(
    Qn,
    {
      forcePage: t,
      pageCount: e,
      onPageChange: a,
      containerClassName: Q.paginationContainer,
      pageClassName: Q.pageItem,
      previousClassName: u,
      nextClassName: p,
      activeClassName: Q.active,
      breakClassName: Q.breakEllipsis,
      previousLabel: /* @__PURE__ */ H("div", { className: Q.labelWrapper, "data-testid": "previous-page-button", children: [
        /* @__PURE__ */ b(st, { className: Q.previousIcon, color: c, size: "xs" }),
        n ? /* @__PURE__ */ b("span", { className: Q.labelText, children: n }) : null
      ] }),
      nextLabel: /* @__PURE__ */ H("div", { className: Q.labelWrapper, "data-testid": "next-page-button", children: [
        o ? /* @__PURE__ */ b("span", { className: Q.labelText, children: o }) : null,
        /* @__PURE__ */ b(st, { className: Q.nextIcon, color: f, size: "xs" })
      ] }),
      marginPagesDisplayed: 1,
      pageRangeDisplayed: 2,
      renderOnZeroPageCount: null,
      pageLinkClassName: "page-link",
      hrefBuilder: r,
      ...i
    }
  ) });
}, lo = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, uo = (t, e, a) => {
  let r;
  const n = lo[t];
  return typeof n == "string" ? r = n : e === 1 ? r = n.one : r = n.other.replace("{{count}}", e.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Ge(t) {
  return (e = {}) => {
    const a = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[a] || t.formats[t.defaultWidth];
  };
}
const co = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, mo = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, fo = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ho = {
  date: Ge({
    formats: co,
    defaultWidth: "full"
  }),
  time: Ge({
    formats: mo,
    defaultWidth: "full"
  }),
  dateTime: Ge({
    formats: fo,
    defaultWidth: "full"
  })
}, vo = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, po = (t, e, a, r) => vo[t];
function Re(t) {
  return (e, a) => {
    const r = a != null && a.context ? String(a.context) : "standalone";
    let n;
    if (r === "formatting" && t.formattingValues) {
      const i = t.defaultFormattingWidth || t.defaultWidth, s = a != null && a.width ? String(a.width) : i;
      n = t.formattingValues[s] || t.formattingValues[i];
    } else {
      const i = t.defaultWidth, s = a != null && a.width ? String(a.width) : t.defaultWidth;
      n = t.values[s] || t.values[i];
    }
    const o = t.argumentCallback ? t.argumentCallback(e) : e;
    return n[o];
  };
}
const go = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, yo = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, bo = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Mo = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, wo = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, _o = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Po = (t, e) => {
  const a = Number(t), r = a % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, xo = {
  ordinalNumber: Po,
  era: Re({
    values: go,
    defaultWidth: "wide"
  }),
  quarter: Re({
    values: yo,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Re({
    values: bo,
    defaultWidth: "wide"
  }),
  day: Re({
    values: Mo,
    defaultWidth: "wide"
  }),
  dayPeriod: Re({
    values: wo,
    defaultWidth: "wide",
    formattingValues: _o,
    defaultFormattingWidth: "wide"
  })
};
function Ae(t) {
  return (e, a = {}) => {
    const r = a.width, n = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], o = e.match(n);
    if (!o)
      return null;
    const i = o[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], d = Array.isArray(s) ? ko(s, (c) => c.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Eo(s, (c) => c.test(i))
    );
    let l;
    l = t.valueCallback ? t.valueCallback(d) : d, l = a.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      a.valueCallback(l)
    ) : l;
    const u = e.slice(i.length);
    return { value: l, rest: u };
  };
}
function Eo(t, e) {
  for (const a in t)
    if (Object.prototype.hasOwnProperty.call(t, a) && e(t[a]))
      return a;
}
function ko(t, e) {
  for (let a = 0; a < t.length; a++)
    if (e(t[a]))
      return a;
}
function Co(t) {
  return (e, a = {}) => {
    const r = e.match(t.matchPattern);
    if (!r)
      return null;
    const n = r[0], o = e.match(t.parsePattern);
    if (!o)
      return null;
    let i = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    i = a.valueCallback ? a.valueCallback(i) : i;
    const s = e.slice(n.length);
    return { value: i, rest: s };
  };
}
const Do = /^(\d+)(th|st|nd|rd)?/i, Oo = /\d+/i, No = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, To = {
  any: [/^b/i, /^(a|c)/i]
}, So = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Wo = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, jo = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, zo = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Lo = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Ro = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Ao = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ho = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Fo = {
  ordinalNumber: Co({
    matchPattern: Do,
    parsePattern: Oo,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Ae({
    matchPatterns: No,
    defaultMatchWidth: "wide",
    parsePatterns: To,
    defaultParseWidth: "any"
  }),
  quarter: Ae({
    matchPatterns: So,
    defaultMatchWidth: "wide",
    parsePatterns: Wo,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Ae({
    matchPatterns: jo,
    defaultMatchWidth: "wide",
    parsePatterns: zo,
    defaultParseWidth: "any"
  }),
  day: Ae({
    matchPatterns: Lo,
    defaultMatchWidth: "wide",
    parsePatterns: Ro,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ae({
    matchPatterns: Ao,
    defaultMatchWidth: "any",
    parsePatterns: Ho,
    defaultParseWidth: "any"
  })
}, qo = {
  code: "en-US",
  formatDistance: uo,
  formatLong: ho,
  formatRelative: po,
  localize: xo,
  match: Fo,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let Io = {};
function qe() {
  return Io;
}
const xr = 6048e5, $o = 864e5;
function de(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function Xa(t) {
  const e = de(t);
  return e.setHours(0, 0, 0, 0), e;
}
function Va(t) {
  const e = de(t), a = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return a.setUTCFullYear(e.getFullYear()), +t - +a;
}
function Yo(t, e) {
  const a = Xa(t), r = Xa(e), n = +a - Va(a), o = +r - Va(r);
  return Math.round((n - o) / $o);
}
function Ee(t, e) {
  return t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Bo(t) {
  const e = de(t), a = Ee(t, 0);
  return a.setFullYear(e.getFullYear(), 0, 1), a.setHours(0, 0, 0, 0), a;
}
function Xo(t) {
  const e = de(t);
  return Yo(e, Bo(e)) + 1;
}
function Fe(t, e) {
  var s, d, l, u;
  const a = qe(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((d = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : d.weekStartsOn) ?? a.weekStartsOn ?? ((u = (l = a.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? 0, n = de(t), o = n.getDay(), i = (o < r ? 7 : 0) + o - r;
  return n.setDate(n.getDate() - i), n.setHours(0, 0, 0, 0), n;
}
function Be(t) {
  return Fe(t, { weekStartsOn: 1 });
}
function Er(t) {
  const e = de(t), a = e.getFullYear(), r = Ee(t, 0);
  r.setFullYear(a + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const n = Be(r), o = Ee(t, 0);
  o.setFullYear(a, 0, 4), o.setHours(0, 0, 0, 0);
  const i = Be(o);
  return e.getTime() >= n.getTime() ? a + 1 : e.getTime() >= i.getTime() ? a : a - 1;
}
function Vo(t) {
  const e = Er(t), a = Ee(t, 0);
  return a.setFullYear(e, 0, 4), a.setHours(0, 0, 0, 0), Be(a);
}
function Uo(t) {
  const e = de(t), a = +Be(e) - +Vo(e);
  return Math.round(a / xr) + 1;
}
function kr(t, e) {
  var u, c, p, f;
  const a = de(t), r = a.getFullYear(), n = qe(), o = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((c = (u = e == null ? void 0 : e.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((f = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, i = Ee(t, 0);
  i.setFullYear(r + 1, 0, o), i.setHours(0, 0, 0, 0);
  const s = Fe(i, e), d = Ee(t, 0);
  d.setFullYear(r, 0, o), d.setHours(0, 0, 0, 0);
  const l = Fe(d, e);
  return a.getTime() >= s.getTime() ? r + 1 : a.getTime() >= l.getTime() ? r : r - 1;
}
function Jo(t, e) {
  var s, d, l, u;
  const a = qe(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((d = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : d.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((u = (l = a.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, n = kr(t, e), o = Ee(t, 0);
  return o.setFullYear(n, 0, r), o.setHours(0, 0, 0, 0), Fe(o, e);
}
function Qo(t, e) {
  const a = de(t), r = +Fe(a, e) - +Jo(a, e);
  return Math.round(r / xr) + 1;
}
function z(t, e) {
  const a = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return a + r;
}
const Me = {
  // Year
  y(t, e) {
    const a = t.getFullYear(), r = a > 0 ? a : 1 - a;
    return z(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const a = t.getMonth();
    return e === "M" ? String(a + 1) : z(a + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return z(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const a = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return z(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return z(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return z(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return z(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const a = e.length, r = t.getMilliseconds(), n = Math.trunc(
      r * Math.pow(10, a - 3)
    );
    return z(n, e.length);
  }
}, Te = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ua = {
  // Era
  G: function(t, e, a) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(r, { width: "abbreviated" });
      case "GGGGG":
        return a.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return a.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, a) {
    if (e === "yo") {
      const r = t.getFullYear(), n = r > 0 ? r : 1 - r;
      return a.ordinalNumber(n, { unit: "year" });
    }
    return Me.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, a, r) {
    const n = kr(t, r), o = n > 0 ? n : 1 - n;
    if (e === "YY") {
      const i = o % 100;
      return z(i, 2);
    }
    return e === "Yo" ? a.ordinalNumber(o, { unit: "year" }) : z(o, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const a = Er(t);
    return z(a, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const a = t.getFullYear();
    return z(a, e.length);
  },
  // Quarter
  Q: function(t, e, a) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(r);
      case "QQ":
        return z(r, 2);
      case "Qo":
        return a.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return a.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, a) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(r);
      case "qq":
        return z(r, 2);
      case "qo":
        return a.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return a.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, a) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Me.M(t, e);
      case "Mo":
        return a.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return a.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return a.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, a) {
    const r = t.getMonth();
    switch (e) {
      case "L":
        return String(r + 1);
      case "LL":
        return z(r + 1, 2);
      case "Lo":
        return a.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return a.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return a.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, a, r) {
    const n = Qo(t, r);
    return e === "wo" ? a.ordinalNumber(n, { unit: "week" }) : z(n, e.length);
  },
  // ISO week of year
  I: function(t, e, a) {
    const r = Uo(t);
    return e === "Io" ? a.ordinalNumber(r, { unit: "week" }) : z(r, e.length);
  },
  // Day of the month
  d: function(t, e, a) {
    return e === "do" ? a.ordinalNumber(t.getDate(), { unit: "date" }) : Me.d(t, e);
  },
  // Day of year
  D: function(t, e, a) {
    const r = Xo(t);
    return e === "Do" ? a.ordinalNumber(r, { unit: "dayOfYear" }) : z(r, e.length);
  },
  // Day of week
  E: function(t, e, a) {
    const r = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return a.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return a.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, a, r) {
    const n = t.getDay(), o = (n - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(o);
      case "ee":
        return z(o, 2);
      case "eo":
        return a.ordinalNumber(o, { unit: "day" });
      case "eee":
        return a.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return a.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(n, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return a.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, a, r) {
    const n = t.getDay(), o = (n - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(o);
      case "cc":
        return z(o, e.length);
      case "co":
        return a.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return a.day(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return a.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(n, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return a.day(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, a) {
    const r = t.getDay(), n = r === 0 ? 7 : r;
    switch (e) {
      case "i":
        return String(n);
      case "ii":
        return z(n, e.length);
      case "io":
        return a.ordinalNumber(n, { unit: "day" });
      case "iii":
        return a.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return a.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return a.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return a.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, a) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return a.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, a) {
    const r = t.getHours();
    let n;
    switch (r === 12 ? n = Te.noon : r === 0 ? n = Te.midnight : n = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return a.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, a) {
    const r = t.getHours();
    let n;
    switch (r >= 17 ? n = Te.evening : r >= 12 ? n = Te.afternoon : r >= 4 ? n = Te.morning : n = Te.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, a) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), a.ordinalNumber(r, { unit: "hour" });
    }
    return Me.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, a) {
    return e === "Ho" ? a.ordinalNumber(t.getHours(), { unit: "hour" }) : Me.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, a) {
    const r = t.getHours() % 12;
    return e === "Ko" ? a.ordinalNumber(r, { unit: "hour" }) : z(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, a) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? a.ordinalNumber(r, { unit: "hour" }) : z(r, e.length);
  },
  // Minute
  m: function(t, e, a) {
    return e === "mo" ? a.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Me.m(t, e);
  },
  // Second
  s: function(t, e, a) {
    return e === "so" ? a.ordinalNumber(t.getSeconds(), { unit: "second" }) : Me.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Me.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, a) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      case "X":
        return Qa(r);
      case "XXXX":
      case "XX":
        return _e(r);
      case "XXXXX":
      case "XXX":
      default:
        return _e(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, a) {
    const r = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return Qa(r);
      case "xxxx":
      case "xx":
        return _e(r);
      case "xxxxx":
      case "xxx":
      default:
        return _e(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, a) {
    const r = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ja(r, ":");
      case "OOOO":
      default:
        return "GMT" + _e(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, a) {
    const r = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ja(r, ":");
      case "zzzz":
      default:
        return "GMT" + _e(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, a) {
    const r = Math.trunc(t.getTime() / 1e3);
    return z(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, a) {
    const r = t.getTime();
    return z(r, e.length);
  }
};
function Ja(t, e = "") {
  const a = t > 0 ? "-" : "+", r = Math.abs(t), n = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? a + String(n) : a + String(n) + e + z(o, 2);
}
function Qa(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + z(Math.abs(t) / 60, 2) : _e(t, e);
}
function _e(t, e = "") {
  const a = t > 0 ? "-" : "+", r = Math.abs(t), n = z(Math.trunc(r / 60), 2), o = z(r % 60, 2);
  return a + n + e + o;
}
const Za = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, Cr = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, Zo = (t, e) => {
  const a = t.match(/(P+)(p+)?/) || [], r = a[1], n = a[2];
  if (!n)
    return Za(t, e);
  let o;
  switch (r) {
    case "P":
      o = e.dateTime({ width: "short" });
      break;
    case "PP":
      o = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = e.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", Za(r, e)).replace("{{time}}", Cr(n, e));
}, Go = {
  p: Cr,
  P: Zo
}, Ko = /^D+$/, ei = /^Y+$/, ti = ["D", "DD", "YY", "YYYY"];
function ai(t) {
  return Ko.test(t);
}
function ri(t) {
  return ei.test(t);
}
function ni(t, e, a) {
  const r = oi(t, e, a);
  if (console.warn(r), ti.includes(t))
    throw new RangeError(r);
}
function oi(t, e, a) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${a}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function ii(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function si(t) {
  if (!ii(t) && typeof t != "number")
    return !1;
  const e = de(t);
  return !isNaN(Number(e));
}
const di = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, li = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ui = /^'([^]*?)'?$/, ci = /''/g, mi = /[a-zA-Z]/;
function fi(t, e, a) {
  var u, c, p, f, m, M, g, w;
  const r = qe(), n = (a == null ? void 0 : a.locale) ?? r.locale ?? qo, o = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((c = (u = a == null ? void 0 : a.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((f = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, i = (a == null ? void 0 : a.weekStartsOn) ?? ((M = (m = a == null ? void 0 : a.locale) == null ? void 0 : m.options) == null ? void 0 : M.weekStartsOn) ?? r.weekStartsOn ?? ((w = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : w.weekStartsOn) ?? 0, s = de(t);
  if (!si(s))
    throw new RangeError("Invalid time value");
  let d = e.match(li).map((x) => {
    const h = x[0];
    if (h === "p" || h === "P") {
      const y = Go[h];
      return y(x, n.formatLong);
    }
    return x;
  }).join("").match(di).map((x) => {
    if (x === "''")
      return { isToken: !1, value: "'" };
    const h = x[0];
    if (h === "'")
      return { isToken: !1, value: hi(x) };
    if (Ua[h])
      return { isToken: !0, value: x };
    if (h.match(mi))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + h + "`"
      );
    return { isToken: !1, value: x };
  });
  n.localize.preprocessor && (d = n.localize.preprocessor(s, d));
  const l = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: n
  };
  return d.map((x) => {
    if (!x.isToken)
      return x.value;
    const h = x.value;
    (!(a != null && a.useAdditionalWeekYearTokens) && ri(h) || !(a != null && a.useAdditionalDayOfYearTokens) && ai(h)) && ni(h, e, String(t));
    const y = Ua[h[0]];
    return y(s, h, n.localize, l);
  }).join("");
}
function hi(t) {
  const e = t.match(ui);
  return e ? e[1].replace(ci, "'") : t;
}
function vi() {
  return Object.assign({}, qe());
}
function Ga(t, e, a) {
  const r = vi(), n = yi(t, a.timeZone, a.locale ?? r.locale);
  return "formatToParts" in n ? pi(n, e) : gi(n, e);
}
function pi(t, e) {
  const a = t.formatToParts(e);
  for (let r = a.length - 1; r >= 0; --r)
    if (a[r].type === "timeZoneName")
      return a[r].value;
}
function gi(t, e) {
  const a = t.format(e).replace(/\u200E/g, ""), r = / [\w-+ ]+$/.exec(a);
  return r ? r[0].substr(1) : "";
}
function yi(t, e, a) {
  return new Intl.DateTimeFormat(a ? [a.code, "en-US"] : void 0, {
    timeZone: e,
    timeZoneName: t
  });
}
function bi(t, e) {
  const a = xi(e);
  return "formatToParts" in a ? wi(a, t) : _i(a, t);
}
const Mi = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function wi(t, e) {
  try {
    const a = t.formatToParts(e), r = [];
    for (let n = 0; n < a.length; n++) {
      const o = Mi[a[n].type];
      o !== void 0 && (r[o] = parseInt(a[n].value, 10));
    }
    return r;
  } catch (a) {
    if (a instanceof RangeError)
      return [NaN];
    throw a;
  }
}
function _i(t, e) {
  const a = t.format(e), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [
    parseInt(r[3], 10),
    parseInt(r[1], 10),
    parseInt(r[2], 10),
    parseInt(r[4], 10),
    parseInt(r[5], 10),
    parseInt(r[6], 10)
  ];
}
const Ke = {}, Ka = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), Pi = Ka === "06/25/2014, 00:00:00" || Ka === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function xi(t) {
  return Ke[t] || (Ke[t] = Pi ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), Ke[t];
}
function Dr(t, e, a, r, n, o, i) {
  const s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(t, e, a), s.setUTCHours(r, n, o, i), s;
}
const er = 36e5, Ei = 6e4, et = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function Aa(t, e, a) {
  if (!t)
    return 0;
  let r = et.timezoneZ.exec(t);
  if (r)
    return 0;
  let n, o;
  if (r = et.timezoneHH.exec(t), r)
    return n = parseInt(r[1], 10), tr(n) ? -(n * er) : NaN;
  if (r = et.timezoneHHMM.exec(t), r) {
    n = parseInt(r[2], 10);
    const i = parseInt(r[3], 10);
    return tr(n, i) ? (o = Math.abs(n) * er + i * Ei, r[1] === "+" ? -o : o) : NaN;
  }
  if (Di(t)) {
    e = new Date(e || Date.now());
    const i = a ? e : ki(e), s = dt(i, t);
    return -(a ? s : Ci(e, s, t));
  }
  return NaN;
}
function ki(t) {
  return Dr(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds());
}
function dt(t, e) {
  const a = bi(t, e), r = Dr(a[0], a[1] - 1, a[2], a[3] % 24, a[4], a[5], 0).getTime();
  let n = t.getTime();
  const o = n % 1e3;
  return n -= o >= 0 ? o : 1e3 + o, r - n;
}
function Ci(t, e, a) {
  let n = t.getTime() - e;
  const o = dt(new Date(n), a);
  if (e === o)
    return e;
  n -= o - e;
  const i = dt(new Date(n), a);
  return o === i ? o : Math.max(o, i);
}
function tr(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
const ar = {};
function Di(t) {
  if (ar[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), ar[t] = !0, !0;
  } catch {
    return !1;
  }
}
const Oi = 60 * 1e3, Ni = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, a) {
    const r = tt(a.timeZone, t);
    if (r === 0)
      return "Z";
    switch (e) {
      case "X":
        return rr(r);
      case "XXXX":
      case "XX":
        return Se(r);
      case "XXXXX":
      case "XXX":
      default:
        return Se(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, a) {
    const r = tt(a.timeZone, t);
    switch (e) {
      case "x":
        return rr(r);
      case "xxxx":
      case "xx":
        return Se(r);
      case "xxxxx":
      case "xxx":
      default:
        return Se(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, a) {
    const r = tt(a.timeZone, t);
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ti(r, ":");
      case "OOOO":
      default:
        return "GMT" + Se(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, a) {
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return Ga("short", t, a);
      case "zzzz":
      default:
        return Ga("long", t, a);
    }
  }
};
function tt(t, e) {
  const a = t ? Aa(t, e, !0) / Oi : (e == null ? void 0 : e.getTimezoneOffset()) ?? 0;
  if (Number.isNaN(a))
    throw new RangeError("Invalid time zone specified: " + t);
  return a;
}
function Xe(t, e) {
  const a = t < 0 ? "-" : "";
  let r = Math.abs(t).toString();
  for (; r.length < e; )
    r = "0" + r;
  return a + r;
}
function Se(t, e = "") {
  const a = t > 0 ? "-" : "+", r = Math.abs(t), n = Xe(Math.floor(r / 60), 2), o = Xe(Math.floor(r % 60), 2);
  return a + n + e + o;
}
function rr(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Xe(Math.abs(t) / 60, 2) : Se(t, e);
}
function Ti(t, e = "") {
  const a = t > 0 ? "-" : "+", r = Math.abs(t), n = Math.floor(r / 60), o = r % 60;
  return o === 0 ? a + String(n) : a + String(n) + e + Xe(o, 2);
}
function nr(t) {
  const e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), +t - +e;
}
const Si = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, at = 36e5, or = 6e4, Wi = 2, Z = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: Si
};
function Or(t, e = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  const a = e.additionalDigits == null ? Wi : Number(e.additionalDigits);
  if (a !== 2 && a !== 1 && a !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (Object.prototype.toString.call(t) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const r = ji(t), { year: n, restDateString: o } = zi(r.date, a), i = Li(o, n);
  if (i === null || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (i) {
    const s = i.getTime();
    let d = 0, l;
    if (r.time && (d = Ri(r.time), d === null || isNaN(d)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || e.timeZone) {
      if (l = Aa(r.timeZone || e.timeZone, new Date(s + d)), isNaN(l))
        return /* @__PURE__ */ new Date(NaN);
    } else
      l = nr(new Date(s + d)), l = nr(new Date(s + d + l));
    return new Date(s + d + l);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function ji(t) {
  const e = {};
  let a = Z.dateTimePattern.exec(t), r;
  if (a ? (e.date = a[1], r = a[3]) : (a = Z.datePattern.exec(t), a ? (e.date = a[1], r = a[2]) : (e.date = null, r = t)), r) {
    const n = Z.timeZone.exec(r);
    n ? (e.time = r.replace(n[1], ""), e.timeZone = n[1].trim()) : e.time = r;
  }
  return e;
}
function zi(t, e) {
  if (t) {
    const a = Z.YYY[e], r = Z.YYYYY[e];
    let n = Z.YYYY.exec(t) || r.exec(t);
    if (n) {
      const o = n[1];
      return {
        year: parseInt(o, 10),
        restDateString: t.slice(o.length)
      };
    }
    if (n = Z.YY.exec(t) || a.exec(t), n) {
      const o = n[1];
      return {
        year: parseInt(o, 10) * 100,
        restDateString: t.slice(o.length)
      };
    }
  }
  return {
    year: null
  };
}
function Li(t, e) {
  if (e === null)
    return null;
  let a, r, n;
  if (!t || !t.length)
    return a = /* @__PURE__ */ new Date(0), a.setUTCFullYear(e), a;
  let o = Z.MM.exec(t);
  if (o)
    return a = /* @__PURE__ */ new Date(0), r = parseInt(o[1], 10) - 1, sr(e, r) ? (a.setUTCFullYear(e, r), a) : /* @__PURE__ */ new Date(NaN);
  if (o = Z.DDD.exec(t), o) {
    a = /* @__PURE__ */ new Date(0);
    const i = parseInt(o[1], 10);
    return Fi(e, i) ? (a.setUTCFullYear(e, 0, i), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = Z.MMDD.exec(t), o) {
    a = /* @__PURE__ */ new Date(0), r = parseInt(o[1], 10) - 1;
    const i = parseInt(o[2], 10);
    return sr(e, r, i) ? (a.setUTCFullYear(e, r, i), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = Z.Www.exec(t), o)
    return n = parseInt(o[1], 10) - 1, dr(n) ? ir(e, n) : /* @__PURE__ */ new Date(NaN);
  if (o = Z.WwwD.exec(t), o) {
    n = parseInt(o[1], 10) - 1;
    const i = parseInt(o[2], 10) - 1;
    return dr(n, i) ? ir(e, n, i) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Ri(t) {
  let e, a, r = Z.HH.exec(t);
  if (r)
    return e = parseFloat(r[1].replace(",", ".")), rt(e) ? e % 24 * at : NaN;
  if (r = Z.HHMM.exec(t), r)
    return e = parseInt(r[1], 10), a = parseFloat(r[2].replace(",", ".")), rt(e, a) ? e % 24 * at + a * or : NaN;
  if (r = Z.HHMMSS.exec(t), r) {
    e = parseInt(r[1], 10), a = parseInt(r[2], 10);
    const n = parseFloat(r[3].replace(",", "."));
    return rt(e, a, n) ? e % 24 * at + a * or + n * 1e3 : NaN;
  }
  return null;
}
function ir(t, e, a) {
  e = e || 0, a = a || 0;
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  const n = r.getUTCDay() || 7, o = e * 7 + a + 1 - n;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
const Ai = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Hi = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Nr(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function sr(t, e, a) {
  if (e < 0 || e > 11)
    return !1;
  if (a != null) {
    if (a < 1)
      return !1;
    const r = Nr(t);
    if (r && a > Hi[e] || !r && a > Ai[e])
      return !1;
  }
  return !0;
}
function Fi(t, e) {
  if (e < 1)
    return !1;
  const a = Nr(t);
  return !(a && e > 366 || !a && e > 365);
}
function dr(t, e) {
  return !(t < 0 || t > 52 || e != null && (e < 0 || e > 6));
}
function rt(t, e, a) {
  return !(t < 0 || t >= 25 || e != null && (e < 0 || e >= 60) || a != null && (a < 0 || a >= 60));
}
const qi = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function Ii(t, e, a = {}) {
  e = String(e);
  const r = e.match(qi);
  if (r) {
    const n = Or(a.originalDate || t, a);
    e = r.reduce(function(o, i) {
      if (i[0] === "'")
        return o;
      const s = o.indexOf(i), d = o[s - 1] === "'", l = o.replace(i, "'" + Ni[i[0]](n, i, a) + "'");
      return d ? l.substring(0, s - 1) + l.substring(s + 1) : l;
    }, e);
  }
  return fi(t, e, a);
}
function $i(t, e, a) {
  t = Or(t, a);
  const r = Aa(e, t, !0), n = new Date(t.getTime() - r), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate()), o.setHours(n.getUTCHours(), n.getUTCMinutes(), n.getUTCSeconds(), n.getUTCMilliseconds()), o;
}
function Yi(t, e, a, r) {
  return r = {
    ...r,
    timeZone: e,
    originalDate: t
  }, Ii($i(t, e, { timeZone: r.timeZone }), a, r);
}
var lt = { exports: {} }, Tr = { exports: {} };
(function(t) {
  function e(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(Tr);
var k = Tr.exports, ut = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "mindre end ét sekund",
      other: "mindre end {{count}} sekunder"
    },
    xSeconds: {
      one: "1 sekund",
      other: "{{count}} sekunder"
    },
    halfAMinute: "ét halvt minut",
    lessThanXMinutes: {
      one: "mindre end ét minut",
      other: "mindre end {{count}} minutter"
    },
    xMinutes: {
      one: "1 minut",
      other: "{{count}} minutter"
    },
    aboutXHours: {
      one: "cirka 1 time",
      other: "cirka {{count}} timer"
    },
    xHours: {
      one: "1 time",
      other: "{{count}} timer"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dage"
    },
    aboutXWeeks: {
      one: "cirka 1 uge",
      other: "cirka {{count}} uger"
    },
    xWeeks: {
      one: "1 uge",
      other: "{{count}} uger"
    },
    aboutXMonths: {
      one: "cirka 1 måned",
      other: "cirka {{count}} måneder"
    },
    xMonths: {
      one: "1 måned",
      other: "{{count}} måneder"
    },
    aboutXYears: {
      one: "cirka 1 år",
      other: "cirka {{count}} år"
    },
    xYears: {
      one: "1 år",
      other: "{{count}} år"
    },
    overXYears: {
      one: "over 1 år",
      other: "over {{count}} år"
    },
    almostXYears: {
      one: "næsten 1 år",
      other: "næsten {{count}} år"
    }
  }, r = function(i, s, d) {
    var l, u = a[i];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", String(s)), d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "om " + l : l + " siden" : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(ut, ut.exports);
var Bi = ut.exports, ct = { exports: {} }, mt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r) {
    return function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = n.width ? String(n.width) : r.defaultWidth, i = r.formats[o] || r.formats[r.defaultWidth];
      return i;
    };
  }
  t.exports = e.default;
})(mt, mt.exports);
var U = mt.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE 'den' d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, i = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(ct, ct.exports);
var Xi = ct.exports, ft = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i går kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'på' eeee 'kl.' p",
    other: "P"
  }, r = function(i, s, d, l) {
    return a[i];
  }, n = r;
  e.default = n, t.exports = e.default;
})(ft, ft.exports);
var Vi = ft.exports, ht = { exports: {} }, vt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r) {
    return function(n, o) {
      var i = o != null && o.context ? String(o.context) : "standalone", s;
      if (i === "formatting" && r.formattingValues) {
        var d = r.defaultFormattingWidth || r.defaultWidth, l = o != null && o.width ? String(o.width) : d;
        s = r.formattingValues[l] || r.formattingValues[d];
      } else {
        var u = r.defaultWidth, c = o != null && o.width ? String(o.width) : r.defaultWidth;
        s = r.values[c] || r.values[u];
      }
      var p = r.argumentCallback ? r.argumentCallback(n) : n;
      return s[p];
    };
  }
  t.exports = e.default;
})(vt, vt.exports);
var ue = vt.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ue), n = {
    narrow: ["fvt", "vt"],
    abbreviated: ["f.v.t.", "v.t."],
    wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
    wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
  }, i = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
  }, s = {
    narrow: ["S", "M", "T", "O", "T", "F", "L"],
    short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
    abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
    wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    }
  }, u = function(m, M) {
    var g = Number(m);
    return g + ".";
  }, c = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(m) {
        return m - 1;
      }
    }),
    month: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = c;
  e.default = p, t.exports = e.default;
})(ht, ht.exports);
var Ui = ht.exports, pt = { exports: {} }, gt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(o) {
    return function(i) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, d = s.width, l = d && o.matchPatterns[d] || o.matchPatterns[o.defaultMatchWidth], u = i.match(l);
      if (!u)
        return null;
      var c = u[0], p = d && o.parsePatterns[d] || o.parsePatterns[o.defaultParseWidth], f = Array.isArray(p) ? n(p, function(g) {
        return g.test(c);
      }) : r(p, function(g) {
        return g.test(c);
      }), m;
      m = o.valueCallback ? o.valueCallback(f) : f, m = s.valueCallback ? s.valueCallback(m) : m;
      var M = i.slice(c.length);
      return {
        value: m,
        rest: M
      };
    };
  }
  function r(o, i) {
    for (var s in o)
      if (o.hasOwnProperty(s) && i(o[s]))
        return s;
  }
  function n(o, i) {
    for (var s = 0; s < o.length; s++)
      if (i(o[s]))
        return s;
  }
  t.exports = e.default;
})(gt, gt.exports);
var ce = gt.exports, yt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r) {
    return function(n) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = n.match(r.matchPattern);
      if (!i)
        return null;
      var s = i[0], d = n.match(r.parsePattern);
      if (!d)
        return null;
      var l = r.valueCallback ? r.valueCallback(d[0]) : d[0];
      l = o.valueCallback ? o.valueCallback(l) : l;
      var u = n.slice(s.length);
      return {
        value: l,
        rest: u
      };
    };
  }
  t.exports = e.default;
})(yt, yt.exports);
var me = yt.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ce), n = a(me), o = /^(\d+)(\.)?/i, i = /\d+/i, s = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
  }, d = {
    any: [/^f/i, /^(v|e)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, c = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, f = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
  }, m = {
    narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
    any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
  }, M = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
  }, g = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /midnat/i,
      noon: /middag/i,
      morning: /morgen/i,
      afternoon: /eftermiddag/i,
      evening: /aften/i,
      night: /nat/i
    }
  }, w = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: i,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: M,
      defaultMatchWidth: "any",
      parsePatterns: g,
      defaultParseWidth: "any"
    })
  }, x = w;
  e.default = x, t.exports = e.default;
})(pt, pt.exports);
var Ji = pt.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Bi), n = a(Xi), o = a(Vi), i = a(Ui), s = a(Ji), d = {
    code: "da",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(lt, lt.exports);
var Qi = lt.exports;
const Zi = /* @__PURE__ */ X(Qi);
var bt = { exports: {} }, Mt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      standalone: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      },
      withPreposition: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      }
    },
    xSeconds: {
      standalone: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      },
      withPreposition: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      }
    },
    halfAMinute: {
      standalone: "halbe Minute",
      withPreposition: "halben Minute"
    },
    lessThanXMinutes: {
      standalone: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      },
      withPreposition: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      }
    },
    xMinutes: {
      standalone: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      },
      withPreposition: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      }
    },
    aboutXHours: {
      standalone: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      },
      withPreposition: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      }
    },
    xHours: {
      standalone: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      },
      withPreposition: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      }
    },
    xDays: {
      standalone: {
        one: "1 Tag",
        other: "{{count}} Tage"
      },
      withPreposition: {
        one: "1 Tag",
        other: "{{count}} Tagen"
      }
    },
    aboutXWeeks: {
      standalone: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      },
      withPreposition: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      }
    },
    xWeeks: {
      standalone: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      },
      withPreposition: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      }
    },
    aboutXMonths: {
      standalone: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monate"
      },
      withPreposition: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monaten"
      }
    },
    xMonths: {
      standalone: {
        one: "1 Monat",
        other: "{{count}} Monate"
      },
      withPreposition: {
        one: "1 Monat",
        other: "{{count}} Monaten"
      }
    },
    aboutXYears: {
      standalone: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahre"
      },
      withPreposition: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahren"
      }
    },
    xYears: {
      standalone: {
        one: "1 Jahr",
        other: "{{count}} Jahre"
      },
      withPreposition: {
        one: "1 Jahr",
        other: "{{count}} Jahren"
      }
    },
    overXYears: {
      standalone: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahre"
      },
      withPreposition: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahren"
      }
    },
    almostXYears: {
      standalone: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahre"
      },
      withPreposition: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahren"
      }
    }
  }, r = function(i, s, d) {
    var l, u = d != null && d.addSuffix ? a[i].withPreposition : a[i].standalone;
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", String(s)), d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "in " + l : "vor " + l : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(Mt, Mt.exports);
var Gi = Mt.exports, wt = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE, do MMMM y",
    // Montag, 7. Januar 2018
    long: "do MMMM y",
    // 7. Januar 2018
    medium: "do MMM y",
    // 7. Jan. 2018
    short: "dd.MM.y"
    // 07.01.2018
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, i = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(wt, wt.exports);
var Ki = wt.exports, _t = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
  }, r = function(i, s, d, l) {
    return a[i];
  }, n = r;
  e.default = n, t.exports = e.default;
})(_t, _t.exports);
var es = _t.exports, Pt = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ue), n = {
    narrow: ["v.Chr.", "n.Chr."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["vor Christus", "nach Christus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
  }, i = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
  }, s = {
    narrow: i.narrow,
    abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
    wide: i.wide
  }, d = {
    narrow: ["S", "M", "D", "M", "D", "F", "S"],
    short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
    wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
  }, l = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachm.",
      evening: "Abend",
      night: "Nacht"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    }
  }, u = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachm.",
      evening: "abends",
      night: "nachts"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    }
  }, c = function(M) {
    var g = Number(M);
    return g + ".";
  }, p = {
    ordinalNumber: c,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(M) {
        return M - 1;
      }
    }),
    month: (0, r.default)({
      values: i,
      formattingValues: s,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: d,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: l,
      defaultWidth: "wide",
      formattingValues: u,
      defaultFormattingWidth: "wide"
    })
  }, f = p;
  e.default = f, t.exports = e.default;
})(Pt, Pt.exports);
var ts = Pt.exports, xt = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ce), n = a(me), o = /^(\d+)(\.)?/i, i = /\d+/i, s = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
  }, d = {
    any: [/^v/i, /^n/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, c = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, f = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
  }, m = {
    any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
  }, M = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
  }, g = {
    any: {
      am: /^v/i,
      pm: /^n/i,
      midnight: /^Mitte/i,
      noon: /^Mitta/i,
      morning: /morgens/i,
      afternoon: /nachmittags/i,
      // will never be matched. Afternoon is matched by `pm`
      evening: /abends/i,
      night: /nachts/i
      // will never be matched. Night is matched by `pm`
    }
  }, w = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: i,
      valueCallback: function(y) {
        return parseInt(y);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: M,
      defaultMatchWidth: "wide",
      parsePatterns: g,
      defaultParseWidth: "any"
    })
  }, x = w;
  e.default = x, t.exports = e.default;
})(xt, xt.exports);
var as = xt.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Gi), n = a(Ki), o = a(es), i = a(ts), s = a(as), d = {
    code: "de",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(bt, bt.exports);
var rs = bt.exports;
const ns = /* @__PURE__ */ X(rs);
var Et = { exports: {} }, kt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, r = function(i, s, d) {
    var l, u = a[i];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", s.toString()), d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "in " + l : l + " ago" : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(kt, kt.exports);
var je = kt.exports, Ct = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, i = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(Ct, Ct.exports);
var os = Ct.exports, Dt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, r = function(i, s, d, l) {
    return a[i];
  }, n = r;
  e.default = n, t.exports = e.default;
})(Dt, Dt.exports);
var ke = Dt.exports, Ot = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ue), n = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, i = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, s = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, u = function(m, M) {
    var g = Number(m), w = g % 100;
    if (w > 20 || w < 10)
      switch (w % 10) {
        case 1:
          return g + "st";
        case 2:
          return g + "nd";
        case 3:
          return g + "rd";
      }
    return g + "th";
  }, c = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(m) {
        return m - 1;
      }
    }),
    month: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = c;
  e.default = p, t.exports = e.default;
})(Ot, Ot.exports);
var Ce = Ot.exports, Nt = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ce), n = a(me), o = /^(\d+)(th|st|nd|rd)?/i, i = /\d+/i, s = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, d = {
    any: [/^b/i, /^(a|c)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, c = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, f = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, m = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, M = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, g = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, w = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: i,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: M,
      defaultMatchWidth: "any",
      parsePatterns: g,
      defaultParseWidth: "any"
    })
  }, x = w;
  e.default = x, t.exports = e.default;
})(Nt, Nt.exports);
var De = Nt.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(je), n = a(os), o = a(ke), i = a(Ce), s = a(De), d = {
    code: "en-AU",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(Et, Et.exports);
var is = Et.exports;
const ss = /* @__PURE__ */ X(is);
var Tt = { exports: {} }, St = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "a second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "a minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about an hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "an hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "a day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about a week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "a week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about a month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "a month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about a year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "a year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over a year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost a year",
      other: "almost {{count}} years"
    }
  }, r = function(i, s, d) {
    var l, u = a[i];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", s.toString()), d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "in " + l : l + " ago" : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(St, St.exports);
var ds = St.exports, Wt = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE, MMMM do, yyyy",
    long: "MMMM do, yyyy",
    medium: "MMM d, yyyy",
    short: "yyyy-MM-dd"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, i = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(Wt, Wt.exports);
var ls = Wt.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ke), n = a(Ce), o = a(De), i = a(ds), s = a(ls), d = {
    code: "en-CA",
    formatDistance: i.default,
    formatLong: s.default,
    formatRelative: r.default,
    localize: n.default,
    match: o.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(Tt, Tt.exports);
var us = Tt.exports;
const cs = /* @__PURE__ */ X(us);
var jt = { exports: {} }, zt = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, i = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(zt, zt.exports);
var ms = zt.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(je), n = a(ke), o = a(Ce), i = a(De), s = a(ms), d = {
    code: "en-GB",
    formatDistance: r.default,
    formatLong: s.default,
    formatRelative: n.default,
    localize: o.default,
    match: i.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(jt, jt.exports);
var fs = jt.exports;
const hs = /* @__PURE__ */ X(fs);
var Lt = { exports: {} }, Rt = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM, yyyy",
    medium: "d MMM, yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, i = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(Rt, Rt.exports);
var vs = Rt.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(je), n = a(ke), o = a(Ce), i = a(De), s = a(vs), d = {
    code: "en-IN",
    formatDistance: r.default,
    formatLong: s.default,
    formatRelative: n.default,
    localize: o.default,
    match: i.default,
    options: {
      weekStartsOn: 1,
      // Monday is the first day of the week.
      firstWeekContainsDate: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(Lt, Lt.exports);
var ps = Lt.exports;
const gs = /* @__PURE__ */ X(ps);
var At = { exports: {} }, Ht = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, i = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(Ht, Ht.exports);
var ys = Ht.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(je), n = a(ke), o = a(Ce), i = a(De), s = a(ys), d = {
    code: "en-NZ",
    formatDistance: r.default,
    formatLong: s.default,
    formatRelative: n.default,
    localize: o.default,
    match: i.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(At, At.exports);
var bs = At.exports;
const Ms = /* @__PURE__ */ X(bs);
var Ft = { exports: {} }, qt = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, i = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(qt, qt.exports);
var ws = qt.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(je), n = a(ws), o = a(ke), i = a(Ce), s = a(De), d = {
    code: "en-US",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(Ft, Ft.exports);
var _s = Ft.exports;
const Ps = /* @__PURE__ */ X(_s);
var It = { exports: {} }, $t = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "yyyy/MM/dd"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, i = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})($t, $t.exports);
var xs = $t.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(je), n = a(ke), o = a(Ce), i = a(De), s = a(xs), d = {
    code: "en-ZA",
    formatDistance: r.default,
    formatLong: s.default,
    formatRelative: n.default,
    localize: o.default,
    match: i.default,
    options: {
      weekStartsOn: 0,
      // Sunday is the first day of the week.
      firstWeekContainsDate: 1
      // The week that contains Jan 1st is the first week of the year.
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(It, It.exports);
var Es = It.exports;
const ks = /* @__PURE__ */ X(Es);
var Yt = { exports: {} }, Bt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "menos de un segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
      one: "menos de un minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "alrededor de 1 hora",
      other: "alrededor de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 día",
      other: "{{count}} días"
    },
    aboutXWeeks: {
      one: "alrededor de 1 semana",
      other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "alrededor de 1 mes",
      other: "alrededor de {{count}} meses"
    },
    xMonths: {
      one: "1 mes",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "alrededor de 1 año",
      other: "alrededor de {{count}} años"
    },
    xYears: {
      one: "1 año",
      other: "{{count}} años"
    },
    overXYears: {
      one: "más de 1 año",
      other: "más de {{count}} años"
    },
    almostXYears: {
      one: "casi 1 año",
      other: "casi {{count}} años"
    }
  }, r = function(i, s, d) {
    var l, u = a[i];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", s.toString()), d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "en " + l : "hace " + l : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(Bt, Bt.exports);
var Cs = Bt.exports, Xt = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, i = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(Xt, Xt.exports);
var Ds = Xt.exports, Vt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'mañana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
  }, r = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'mañana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
  }, n = function(s, d, l, u) {
    return d.getUTCHours() !== 1 ? r[s] : a[s];
  }, o = n;
  e.default = o, t.exports = e.default;
})(Vt, Vt.exports);
var Os = Vt.exports, Ut = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ue), n = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "después de cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, i = {
    narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
  }, s = {
    narrow: ["d", "l", "m", "m", "j", "v", "s"],
    short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
    abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    }
  }, u = function(m, M) {
    var g = Number(m);
    return g + "º";
  }, c = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(m) {
        return Number(m) - 1;
      }
    }),
    month: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = c;
  e.default = p, t.exports = e.default;
})(Ut, Ut.exports);
var Ns = Ut.exports, Jt = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(me), n = a(ce), o = /^(\d+)(º)?/i, i = /\d+/i, s = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
  }, d = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, c = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
  }, p = {
    narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
  }, f = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
  }, m = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
  }, M = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
  }, g = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn/i,
      noon: /^md/i,
      morning: /mañana/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noche/i
    }
  }, w = {
    ordinalNumber: (0, r.default)({
      matchPattern: o,
      parsePattern: i,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, n.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, n.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, n.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, n.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, n.default)({
      matchPatterns: M,
      defaultMatchWidth: "any",
      parsePatterns: g,
      defaultParseWidth: "any"
    })
  }, x = w;
  e.default = x, t.exports = e.default;
})(Jt, Jt.exports);
var Ts = Jt.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Cs), n = a(Ds), o = a(Os), i = a(Ns), s = a(Ts), d = {
    code: "es",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 1
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(Yt, Yt.exports);
var Ss = Yt.exports;
const Ws = /* @__PURE__ */ X(Ss);
var Qt = { exports: {} }, Zt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "moins d’une seconde",
      other: "moins de {{count}} secondes"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
      one: "moins d’une minute",
      other: "moins de {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "environ 1 heure",
      other: "environ {{count}} heures"
    },
    xHours: {
      one: "1 heure",
      other: "{{count}} heures"
    },
    xDays: {
      one: "1 jour",
      other: "{{count}} jours"
    },
    aboutXWeeks: {
      one: "environ 1 semaine",
      other: "environ {{count}} semaines"
    },
    xWeeks: {
      one: "1 semaine",
      other: "{{count}} semaines"
    },
    aboutXMonths: {
      one: "environ 1 mois",
      other: "environ {{count}} mois"
    },
    xMonths: {
      one: "1 mois",
      other: "{{count}} mois"
    },
    aboutXYears: {
      one: "environ 1 an",
      other: "environ {{count}} ans"
    },
    xYears: {
      one: "1 an",
      other: "{{count}} ans"
    },
    overXYears: {
      one: "plus d’un an",
      other: "plus de {{count}} ans"
    },
    almostXYears: {
      one: "presqu’un an",
      other: "presque {{count}} ans"
    }
  }, r = function(i, s, d) {
    var l, u = a[i];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", String(s)), d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "dans " + l : "il y a " + l : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(Zt, Zt.exports);
var js = Zt.exports, Gt = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, i = {
    full: "{{date}} 'à' {{time}}",
    long: "{{date}} 'à' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(Gt, Gt.exports);
var zs = Gt.exports, Kt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "eeee 'dernier à' p",
    yesterday: "'hier à' p",
    today: "'aujourd’hui à' p",
    tomorrow: "'demain à' p'",
    nextWeek: "eeee 'prochain à' p",
    other: "P"
  }, r = function(i, s, d, l) {
    return a[i];
  }, n = r;
  e.default = n, t.exports = e.default;
})(Kt, Kt.exports);
var Ls = Kt.exports, ea = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ue), n = {
    narrow: ["av. J.-C", "ap. J.-C"],
    abbreviated: ["av. J.-C", "ap. J.-C"],
    wide: ["avant Jésus-Christ", "après Jésus-Christ"]
  }, o = {
    narrow: ["T1", "T2", "T3", "T4"],
    abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
    wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
  }, i = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
    wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
  }, s = {
    narrow: ["D", "L", "M", "M", "J", "V", "S"],
    short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
    abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
    wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
  }, d = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "mat.",
      afternoon: "ap.m.",
      evening: "soir",
      night: "mat."
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "matin",
      afternoon: "après-midi",
      evening: "soir",
      night: "matin"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "du matin",
      afternoon: "de l’après-midi",
      evening: "du soir",
      night: "du matin"
    }
  }, l = function(f, m) {
    var M = Number(f), g = m == null ? void 0 : m.unit;
    if (M === 0)
      return "0";
    var w = ["year", "week", "hour", "minute", "second"], x;
    return M === 1 ? x = g && w.includes(g) ? "ère" : "er" : x = "ème", M + x;
  }, u = {
    ordinalNumber: l,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(f) {
        return f - 1;
      }
    }),
    month: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: d,
      defaultWidth: "wide"
    })
  }, c = u;
  e.default = c, t.exports = e.default;
})(ea, ea.exports);
var Rs = ea.exports, ta = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ce), n = a(me), o = /^(\d+)(ième|ère|ème|er|e)?/i, i = /\d+/i, s = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
  }, d = {
    any: [/^av/i, /^ap/i]
  }, l = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, c = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, f = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
  }, m = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
  }, M = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
  }, g = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^min/i,
      noon: /^mid/i,
      morning: /mat/i,
      afternoon: /ap/i,
      evening: /soir/i,
      night: /nuit/i
    }
  }, w = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: i,
      valueCallback: function(y) {
        return parseInt(y);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: M,
      defaultMatchWidth: "any",
      parsePatterns: g,
      defaultParseWidth: "any"
    })
  }, x = w;
  e.default = x, t.exports = e.default;
})(ta, ta.exports);
var As = ta.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(js), n = a(zs), o = a(Ls), i = a(Rs), s = a(As), d = {
    code: "fr",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(Qt, Qt.exports);
var Hs = Qt.exports;
const Fs = /* @__PURE__ */ X(Hs);
var aa = { exports: {} }, ra = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "meno di un secondo",
      other: "meno di {{count}} secondi"
    },
    xSeconds: {
      one: "un secondo",
      other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
      one: "meno di un minuto",
      other: "meno di {{count}} minuti"
    },
    xMinutes: {
      one: "un minuto",
      other: "{{count}} minuti"
    },
    aboutXHours: {
      one: "circa un'ora",
      other: "circa {{count}} ore"
    },
    xHours: {
      one: "un'ora",
      other: "{{count}} ore"
    },
    xDays: {
      one: "un giorno",
      other: "{{count}} giorni"
    },
    aboutXWeeks: {
      one: "circa una settimana",
      other: "circa {{count}} settimane"
    },
    xWeeks: {
      one: "una settimana",
      other: "{{count}} settimane"
    },
    aboutXMonths: {
      one: "circa un mese",
      other: "circa {{count}} mesi"
    },
    xMonths: {
      one: "un mese",
      other: "{{count}} mesi"
    },
    aboutXYears: {
      one: "circa un anno",
      other: "circa {{count}} anni"
    },
    xYears: {
      one: "un anno",
      other: "{{count}} anni"
    },
    overXYears: {
      one: "più di un anno",
      other: "più di {{count}} anni"
    },
    almostXYears: {
      one: "quasi un anno",
      other: "quasi {{count}} anni"
    }
  }, r = function(i, s, d) {
    var l, u = a[i];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", s.toString()), d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "tra " + l : l + " fa" : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(ra, ra.exports);
var qs = ra.exports, na = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, i = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(na, na.exports);
var Is = na.exports, oa = { exports: {} }, ia = { exports: {} }, sa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r, n) {
    if (n.length < r)
      throw new TypeError(r + " argument" + (r > 1 ? "s" : "") + " required, but only " + n.length + " present");
  }
  t.exports = e.default;
})(sa, sa.exports);
var Ha = sa.exports, da = { exports: {} }, la = { exports: {} }, Sr = { exports: {} };
(function(t) {
  function e(a) {
    "@babel/helpers - typeof";
    return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(a);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(Sr);
var $s = Sr.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var r = a($s), n = a(Ha);
  function o(i) {
    (0, n.default)(1, arguments);
    var s = Object.prototype.toString.call(i);
    return i instanceof Date || (0, r.default)(i) === "object" && s === "[object Date]" ? new Date(i.getTime()) : typeof i == "number" || s === "[object Number]" ? new Date(i) : ((typeof i == "string" || s === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  t.exports = e.default;
})(la, la.exports);
var Ys = la.exports, ua = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var n = Number(r);
    return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  t.exports = e.default;
})(ua, ua.exports);
var Bs = ua.exports, Ue = {};
Object.defineProperty(Ue, "__esModule", {
  value: !0
});
Ue.getDefaultOptions = Xs;
Ue.setDefaultOptions = Vs;
var Wr = {};
function Xs() {
  return Wr;
}
function Vs(t) {
  Wr = t;
}
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = s;
  var r = a(Ys), n = a(Ha), o = a(Bs), i = Ue;
  function s(d, l) {
    var u, c, p, f, m, M, g, w;
    (0, n.default)(1, arguments);
    var x = (0, i.getDefaultOptions)(), h = (0, o.default)((u = (c = (p = (f = l == null ? void 0 : l.weekStartsOn) !== null && f !== void 0 ? f : l == null || (m = l.locale) === null || m === void 0 || (M = m.options) === null || M === void 0 ? void 0 : M.weekStartsOn) !== null && p !== void 0 ? p : x.weekStartsOn) !== null && c !== void 0 ? c : (g = x.locale) === null || g === void 0 || (w = g.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && u !== void 0 ? u : 0);
    if (!(h >= 0 && h <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var y = (0, r.default)(d), D = y.getUTCDay(), R = (D < h ? 7 : 0) + D - h;
    return y.setUTCDate(y.getUTCDate() - R), y.setUTCHours(0, 0, 0, 0), y;
  }
  t.exports = e.default;
})(da, da.exports);
var Us = da.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var r = a(Ha), n = a(Us);
  function o(i, s, d) {
    (0, r.default)(2, arguments);
    var l = (0, n.default)(i, d), u = (0, n.default)(s, d);
    return l.getTime() === u.getTime();
  }
  t.exports = e.default;
})(ia, ia.exports);
var Js = ia.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Js), n = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
  function o(c) {
    switch (c) {
      case 0:
        return "'domenica scorsa alle' p";
      default:
        return "'" + n[c] + " scorso alle' p";
    }
  }
  function i(c) {
    return "'" + n[c] + " alle' p";
  }
  function s(c) {
    switch (c) {
      case 0:
        return "'domenica prossima alle' p";
      default:
        return "'" + n[c] + " prossimo alle' p";
    }
  }
  var d = {
    lastWeek: function(p, f, m) {
      var M = p.getUTCDay();
      return (0, r.default)(p, f, m) ? i(M) : o(M);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function(p, f, m) {
      var M = p.getUTCDay();
      return (0, r.default)(p, f, m) ? i(M) : s(M);
    },
    other: "P"
  }, l = function(p, f, m, M) {
    var g = d[p];
    return typeof g == "function" ? g(f, m, M) : g;
  }, u = l;
  e.default = u, t.exports = e.default;
})(oa, oa.exports);
var Qs = oa.exports, ca = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ue), n = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["avanti Cristo", "dopo Cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, i = {
    narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
    abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
    wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
  }, s = {
    narrow: ["D", "L", "M", "M", "G", "V", "S"],
    short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
  }, d = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    }
  }, l = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    }
  }, u = function(m, M) {
    var g = Number(m);
    return String(g);
  }, c = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(m) {
        return m - 1;
      }
    }),
    month: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = c;
  e.default = p, t.exports = e.default;
})(ca, ca.exports);
var Zs = ca.exports, ma = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ce), n = a(me), o = /^(\d+)(º)?/i, i = /\d+/i, s = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
  }, d = {
    any: [/^a/i, /^(d|e)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, c = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
  }, p = {
    narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, f = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
  }, m = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
    any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
  }, M = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
  }, g = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mezza/i,
      noon: /^mezzo/i,
      morning: /mattina/i,
      afternoon: /pomeriggio/i,
      evening: /sera/i,
      night: /notte/i
    }
  }, w = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: i,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: M,
      defaultMatchWidth: "any",
      parsePatterns: g,
      defaultParseWidth: "any"
    })
  }, x = w;
  e.default = x, t.exports = e.default;
})(ma, ma.exports);
var Gs = ma.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(qs), n = a(Is), o = a(Qs), i = a(Zs), s = a(Gs), d = {
    code: "it",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(aa, aa.exports);
var Ks = aa.exports;
const ed = /* @__PURE__ */ X(Ks);
var fa = { exports: {} }, ha = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "minder dan een seconde",
      other: "minder dan {{count}} seconden"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
      one: "minder dan een minuut",
      other: "minder dan {{count}} minuten"
    },
    xMinutes: {
      one: "een minuut",
      other: "{{count}} minuten"
    },
    aboutXHours: {
      one: "ongeveer 1 uur",
      other: "ongeveer {{count}} uur"
    },
    xHours: {
      one: "1 uur",
      other: "{{count}} uur"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dagen"
    },
    aboutXWeeks: {
      one: "ongeveer 1 week",
      other: "ongeveer {{count}} weken"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weken"
    },
    aboutXMonths: {
      one: "ongeveer 1 maand",
      other: "ongeveer {{count}} maanden"
    },
    xMonths: {
      one: "1 maand",
      other: "{{count}} maanden"
    },
    aboutXYears: {
      one: "ongeveer 1 jaar",
      other: "ongeveer {{count}} jaar"
    },
    xYears: {
      one: "1 jaar",
      other: "{{count}} jaar"
    },
    overXYears: {
      one: "meer dan 1 jaar",
      other: "meer dan {{count}} jaar"
    },
    almostXYears: {
      one: "bijna 1 jaar",
      other: "bijna {{count}} jaar"
    }
  }, r = function(i, s, d) {
    var l, u = a[i];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", String(s)), d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "over " + l : l + " geleden" : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(ha, ha.exports);
var td = ha.exports, va = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, i = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(va, va.exports);
var ad = va.exports, pa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
  }, r = function(i, s, d, l) {
    return a[i];
  }, n = r;
  e.default = n, t.exports = e.default;
})(pa, pa.exports);
var rd = pa.exports, ga = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ue), n = {
    narrow: ["v.C.", "n.C."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["voor Christus", "na Christus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["K1", "K2", "K3", "K4"],
    wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
  }, i = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
  }, s = {
    narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
    short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
    abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
    wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
  }, d = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    }
  }, l = function(f, m) {
    var M = Number(f);
    return M + "e";
  }, u = {
    ordinalNumber: l,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(f) {
        return f - 1;
      }
    }),
    month: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: d,
      defaultWidth: "wide"
    })
  }, c = u;
  e.default = c, t.exports = e.default;
})(ga, ga.exports);
var nd = ga.exports, ya = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ce), n = a(me), o = /^(\d+)e?/i, i = /\d+/i, s = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
  }, d = {
    any: [/^v/, /^n/]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, c = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
  }, f = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
  }, m = {
    narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
    any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
  }, M = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
  }, g = {
    any: {
      am: /^am/i,
      pm: /^pm/i,
      midnight: /^middernacht/i,
      noon: /^het middaguur/i,
      morning: /ochtend/i,
      afternoon: /middag/i,
      evening: /avond/i,
      night: /nacht/i
    }
  }, w = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: i,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: M,
      defaultMatchWidth: "any",
      parsePatterns: g,
      defaultParseWidth: "any"
    })
  }, x = w;
  e.default = x, t.exports = e.default;
})(ya, ya.exports);
var od = ya.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(td), n = a(ad), o = a(rd), i = a(nd), s = a(od), d = {
    code: "nl",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(fa, fa.exports);
var id = fa.exports;
const sd = /* @__PURE__ */ X(id);
var ba = { exports: {} }, Ma = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "menos de um segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
      one: "menos de um minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "aproximadamente 1 hora",
      other: "aproximadamente {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 dia",
      other: "{{count}} dias"
    },
    aboutXWeeks: {
      one: "aproximadamente 1 semana",
      other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "aproximadamente 1 mês",
      other: "aproximadamente {{count}} meses"
    },
    xMonths: {
      one: "1 mês",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "aproximadamente 1 ano",
      other: "aproximadamente {{count}} anos"
    },
    xYears: {
      one: "1 ano",
      other: "{{count}} anos"
    },
    overXYears: {
      one: "mais de 1 ano",
      other: "mais de {{count}} anos"
    },
    almostXYears: {
      one: "quase 1 ano",
      other: "quase {{count}} anos"
    }
  }, r = function(i, s, d) {
    var l, u = a[i];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", String(s)), d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "daqui a " + l : "há " + l : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(Ma, Ma.exports);
var dd = Ma.exports, wa = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, i = {
    full: "{{date}} 'às' {{time}}",
    long: "{{date}} 'às' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(wa, wa.exports);
var ld = wa.exports, _a = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: function(i) {
      var s = i.getUTCDay(), d = s === 0 || s === 6 ? "último" : "última";
      return "'" + d + "' eeee 'às' p";
    },
    yesterday: "'ontem às' p",
    today: "'hoje às' p",
    tomorrow: "'amanhã às' p",
    nextWeek: "eeee 'às' p",
    other: "P"
  }, r = function(i, s, d, l) {
    var u = a[i];
    return typeof u == "function" ? u(s) : u;
  }, n = r;
  e.default = n, t.exports = e.default;
})(_a, _a.exports);
var ud = _a.exports, Pa = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ue), n = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["antes de Cristo", "depois de Cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, i = {
    narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
  }, s = {
    narrow: ["d", "s", "t", "q", "q", "s", "s"],
    short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
  }, d = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    }
  }, l = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    }
  }, u = function(m, M) {
    var g = Number(m);
    return g + "º";
  }, c = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(m) {
        return m - 1;
      }
    }),
    month: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = c;
  e.default = p, t.exports = e.default;
})(Pa, Pa.exports);
var cd = Pa.exports, xa = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ce), n = a(me), o = /^(\d+)(º|ª)?/i, i = /\d+/i, s = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
  }, d = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, c = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, f = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
  }, m = {
    narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
    any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
  }, M = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
  }, g = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^meia/i,
      noon: /^meio/i,
      morning: /manh[ãa]/i,
      afternoon: /tarde/i,
      evening: /noite/i,
      night: /madrugada/i
    }
  }, w = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: i,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: M,
      defaultMatchWidth: "any",
      parsePatterns: g,
      defaultParseWidth: "any"
    })
  }, x = w;
  e.default = x, t.exports = e.default;
})(xa, xa.exports);
var md = xa.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(dd), n = a(ld), o = a(ud), i = a(cd), s = a(md), d = {
    code: "pt",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(ba, ba.exports);
var fd = ba.exports;
const hd = /* @__PURE__ */ X(fd);
var Ea = { exports: {} }, ka = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "menos de um segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
      one: "menos de um minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "cerca de 1 hora",
      other: "cerca de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 dia",
      other: "{{count}} dias"
    },
    aboutXWeeks: {
      one: "cerca de 1 semana",
      other: "cerca de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "cerca de 1 mês",
      other: "cerca de {{count}} meses"
    },
    xMonths: {
      one: "1 mês",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "cerca de 1 ano",
      other: "cerca de {{count}} anos"
    },
    xYears: {
      one: "1 ano",
      other: "{{count}} anos"
    },
    overXYears: {
      one: "mais de 1 ano",
      other: "mais de {{count}} anos"
    },
    almostXYears: {
      one: "quase 1 ano",
      other: "quase {{count}} anos"
    }
  }, r = function(i, s, d) {
    var l, u = a[i];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", String(s)), d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "em " + l : "há " + l : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(ka, ka.exports);
var vd = ka.exports, Ca = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, i = {
    full: "{{date}} 'às' {{time}}",
    long: "{{date}} 'às' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(Ca, Ca.exports);
var pd = Ca.exports, Da = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: function(i) {
      var s = i.getUTCDay(), d = s === 0 || s === 6 ? "último" : "última";
      return "'" + d + "' eeee 'às' p";
    },
    yesterday: "'ontem às' p",
    today: "'hoje às' p",
    tomorrow: "'amanhã às' p",
    nextWeek: "eeee 'às' p",
    other: "P"
  }, r = function(i, s, d, l) {
    var u = a[i];
    return typeof u == "function" ? u(s) : u;
  }, n = r;
  e.default = n, t.exports = e.default;
})(Da, Da.exports);
var gd = Da.exports, Oa = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ue), n = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "depois de cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, i = {
    narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
  }, s = {
    narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
    short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
    abbreviated: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
    wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    }
  }, u = function(m, M) {
    var g = Number(m);
    return (M == null ? void 0 : M.unit) === "week" ? g + "ª" : g + "º";
  }, c = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(m) {
        return m - 1;
      }
    }),
    month: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = c;
  e.default = p, t.exports = e.default;
})(Oa, Oa.exports);
var yd = Oa.exports, Na = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ce), n = a(me), o = /^(\d+)[ºªo]?/i, i = /\d+/i, s = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
  }, d = {
    any: [/^ac/i, /^dc/i],
    wide: [/^antes de cristo/i, /^depois de cristo/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, c = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
  }, f = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
  }, m = {
    short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
    narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
    any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
  }, M = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
  }, g = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn|^meia[-\s]noite/i,
      noon: /^md|^meio[-\s]dia/i,
      morning: /manhã/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noite/i
    }
  }, w = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: i,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: M,
      defaultMatchWidth: "any",
      parsePatterns: g,
      defaultParseWidth: "any"
    })
  }, x = w;
  e.default = x, t.exports = e.default;
})(Na, Na.exports);
var bd = Na.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(vd), n = a(pd), o = a(gd), i = a(yd), s = a(bd), d = {
    code: "pt-BR",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(Ea, Ea.exports);
var Md = Ea.exports;
const wd = /* @__PURE__ */ X(Md);
var Ta = { exports: {} }, Sa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "mindre än en sekund",
      other: "mindre än {{count}} sekunder"
    },
    xSeconds: {
      one: "en sekund",
      other: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
      one: "mindre än en minut",
      other: "mindre än {{count}} minuter"
    },
    xMinutes: {
      one: "en minut",
      other: "{{count}} minuter"
    },
    aboutXHours: {
      one: "ungefär en timme",
      other: "ungefär {{count}} timmar"
    },
    xHours: {
      one: "en timme",
      other: "{{count}} timmar"
    },
    xDays: {
      one: "en dag",
      other: "{{count}} dagar"
    },
    aboutXWeeks: {
      one: "ungefär en vecka",
      other: "ungefär {{count}} vecka"
    },
    xWeeks: {
      one: "en vecka",
      other: "{{count}} vecka"
    },
    aboutXMonths: {
      one: "ungefär en månad",
      other: "ungefär {{count}} månader"
    },
    xMonths: {
      one: "en månad",
      other: "{{count}} månader"
    },
    aboutXYears: {
      one: "ungefär ett år",
      other: "ungefär {{count}} år"
    },
    xYears: {
      one: "ett år",
      other: "{{count}} år"
    },
    overXYears: {
      one: "över ett år",
      other: "över {{count}} år"
    },
    almostXYears: {
      one: "nästan ett år",
      other: "nästan {{count}} år"
    }
  }, r = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], n = function(s, d, l) {
    var u, c = a[s];
    return typeof c == "string" ? u = c : d === 1 ? u = c.one : l && l.onlyNumeric ? u = c.other.replace("{{count}}", String(d)) : u = c.other.replace("{{count}}", d < 13 ? r[d] : String(d)), l != null && l.addSuffix ? l.comparison && l.comparison > 0 ? "om " + u : u + " sedan" : u;
  }, o = n;
  e.default = o, t.exports = e.default;
})(Sa, Sa.exports);
var _d = Sa.exports, Wa = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(U), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "y-MM-dd"
  }, o = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, i = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    })
  }, d = s;
  e.default = d, t.exports = e.default;
})(Wa, Wa.exports);
var Pd = Wa.exports, ja = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'igår kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
  }, r = function(i, s, d, l) {
    return a[i];
  }, n = r;
  e.default = n, t.exports = e.default;
})(ja, ja.exports);
var xd = ja.exports, za = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ue), n = {
    narrow: ["f.Kr.", "e.Kr."],
    abbreviated: ["f.Kr.", "e.Kr."],
    wide: ["före Kristus", "efter Kristus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
  }, i = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
  }, s = {
    narrow: ["S", "M", "T", "O", "T", "F", "L"],
    short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
    abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
    wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
  }, d = {
    narrow: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "morg.",
      afternoon: "efterm.",
      evening: "kväll",
      night: "natt"
    },
    abbreviated: {
      am: "f.m.",
      pm: "e.m.",
      midnight: "midnatt",
      noon: "middag",
      morning: "morgon",
      afternoon: "efterm.",
      evening: "kväll",
      night: "natt"
    },
    wide: {
      am: "förmiddag",
      pm: "eftermiddag",
      midnight: "midnatt",
      noon: "middag",
      morning: "morgon",
      afternoon: "eftermiddag",
      evening: "kväll",
      night: "natt"
    }
  }, l = {
    narrow: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morg.",
      afternoon: "på efterm.",
      evening: "på kvällen",
      night: "på natten"
    },
    abbreviated: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morg.",
      afternoon: "på efterm.",
      evening: "på kvällen",
      night: "på natten"
    },
    wide: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morgonen",
      afternoon: "på eftermiddagen",
      evening: "på kvällen",
      night: "på natten"
    }
  }, u = function(m, M) {
    var g = Number(m), w = g % 100;
    if (w > 20 || w < 10)
      switch (w % 10) {
        case 1:
        case 2:
          return g + ":a";
      }
    return g + ":e";
  }, c = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(m) {
        return m - 1;
      }
    }),
    month: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = c;
  e.default = p, t.exports = e.default;
})(za, za.exports);
var Ed = za.exports, La = { exports: {} };
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ce), n = a(me), o = /^(\d+)(:a|:e)?/i, i = /\d+/i, s = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
  }, d = {
    any: [/^f/i, /^[ev]/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, c = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, f = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
  }, m = {
    any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
  }, M = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
  }, g = {
    any: {
      am: /^f/i,
      pm: /^e/i,
      midnight: /^midn/i,
      noon: /^midd/i,
      morning: /morgon/i,
      afternoon: /eftermiddag/i,
      evening: /kväll/i,
      night: /natt/i
    }
  }, w = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: i,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: M,
      defaultMatchWidth: "any",
      parsePatterns: g,
      defaultParseWidth: "any"
    })
  }, x = w;
  e.default = x, t.exports = e.default;
})(La, La.exports);
var kd = La.exports;
(function(t, e) {
  var a = k.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(_d), n = a(Pd), o = a(xd), i = a(Ed), s = a(kd), d = {
    code: "sv",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = d;
  e.default = l, t.exports = e.default;
})(Ta, Ta.exports);
var Cd = Ta.exports;
const Dd = /* @__PURE__ */ X(Cd), L = {
  da: Zi,
  de: ns,
  enAU: ss,
  enCA: cs,
  enGB: hs,
  enIN: gs,
  enNZ: Ms,
  enUS: Ps,
  enZA: ks,
  es: Ws,
  fr: Fs,
  it: ed,
  nl: sd,
  pt: hd,
  ptBR: wd,
  sv: Dd
}, nt = {
  AU: {
    countryCode: "AU",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: L.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-AU",
    name: "AU"
  },
  BR: {
    countryCode: "BR",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "HH:mm a",
        timeDateFull: "d 'de' MMM yyyy, HH:mm",
        timeDateShort: "d 'de' MMM, HH:mm",
        timeDayDateShort: "EEE, d 'de' MMM, HH:mm"
      },
      locale: L.ptBR,
      timezone: "America/Sao_Paulo",
      today: "Hoje"
    },
    locale: "pt-BR",
    name: "BR"
  },
  CA: {
    countryCode: "CA",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm a",
        timeDateFull: "MMMM d, yyyy, h:mm a",
        timeDateShort: "MMM d, h:mm a",
        timeDayDateShort: "EEE, MMM d, h:mm a"
      },
      locale: L.enCA,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-CA",
    name: "CA"
  },
  CO: {
    countryCode: "CO",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: L.es,
      timezone: "America/Bogota",
      today: "Hoy"
    },
    locale: "es-CO",
    name: "CO"
  },
  CX: {
    countryCode: "CX",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: L.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-CX",
    name: "CX"
  },
  DE: {
    countryCode: "DE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE, d. MMM, HH:mm"
      },
      locale: L.de,
      timezone: "Europe/Berlin",
      today: "Heute"
    },
    locale: "de-DE",
    name: "DE"
  },
  DK: {
    countryCode: "DK",
    dateProperties: {
      format: {
        dateFull: "EEEE 'den' d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE 'den' d. MMM, HH:mm"
      },
      locale: L.da,
      timezone: "Europe/Copenhagen",
      today: "I dag"
    },
    locale: "da-DK",
    name: "DK"
  },
  ES: {
    countryCode: "ES",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: L.es,
      timezone: "Europe/Madrid",
      today: "Hoy"
    },
    locale: "es-ES",
    name: "ES"
  },
  FR: {
    countryCode: "FR",
    dateProperties: {
      format: {
        dateFull: "EEEE d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: L.fr,
      timezone: "Europe/Paris",
      today: "Aujourd'hui"
    },
    locale: "fr-FR",
    name: "FR"
  },
  GZ: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: L.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "GZ"
  },
  IN: {
    countryCode: "IN",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: L.enIN,
      timezone: "Asia/Kolkata",
      today: "Today"
    },
    locale: "en-IN",
    name: "IN"
  },
  IT: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: L.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "IT"
  },
  KE: {
    countryCode: "KE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: L.enGB,
      timezone: "Africa/Nairobi",
      today: "Today"
    },
    locale: "en-KE",
    name: "KE"
  },
  NG: {
    countryCode: "NG",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: L.enGB,
      timezone: "Africa/Lagos",
      today: "Today"
    },
    locale: "en-NG",
    name: "NG"
  },
  NL: {
    countryCode: "NL",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: L.nl,
      timezone: "Europe/Amsterdam",
      today: "Vandaag"
    },
    locale: "nl-NL",
    name: "NL"
  },
  NZ: {
    countryCode: "NZ",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: L.enNZ,
      timezone: "Pacific/Auckland",
      today: "Today"
    },
    locale: "en-NZ",
    name: "NZ"
  },
  OC: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: L.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "OC"
  },
  PT: {
    countryCode: "PT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: L.pt,
      timezone: "Europe/Lisbon",
      today: "Hoje"
    },
    locale: "pt-PT",
    name: "PT"
  },
  SE: {
    countryCode: "SE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: L.sv,
      timezone: "Europe/Stockholm",
      today: "Idag"
    },
    locale: "sv-SE",
    name: "SE"
  },
  SM: {
    countryCode: "SM",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: L.it,
      timezone: "Europe/San_Marino",
      today: "Oggi"
    },
    locale: "it-SM",
    name: "SM"
  },
  US: {
    countryCode: "US",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm aa zzz",
        timeDateFull: "MMMM d, yyyy, h:mm aa zzz",
        timeDateShort: "MM/dd h:mm aa",
        timeDayDateShort: "EEE MMM d, h:mm aa zzz"
      },
      locale: L.enUS,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-US",
    name: "US"
  },
  WS: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: L.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "WS"
  },
  XX: {
    countryCode: "XX",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: L.enUS,
      // Placeholder locale
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "xx-XX",
    name: "XX"
  },
  ZA: {
    countryCode: "ZA",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: L.enZA,
      timezone: "Africa/Johannesburg",
      today: "Today"
    },
    locale: "en-ZA",
    name: "ZA"
  }
}, jr = (t, e) => t ? Yi(
  t,
  nt[e].dateProperties.timezone,
  nt[e].dateProperties.format.timeDateFull,
  {
    locale: nt[e].dateProperties.locale
  }
) : "", zr = (t, e, a) => {
  a && a.startsWith("http") && (a = a.replace(/^http:/, "https:"));
  const r = a || "https://www.oddschecker.com", n = e.toLowerCase(), o = t.startsWith("/") ? t.slice(1) : t;
  return `${r}/${n}/${o}`;
}, Od = "_imageContainer_p8mnt_1", Nd = "_overlay_p8mnt_18", Td = "_focusTopLeft_p8mnt_36", Sd = "_focusTopCenter_p8mnt_40", Wd = "_focusTopRight_p8mnt_44", jd = "_focusCenterLeft_p8mnt_48", zd = "_focusCenter_p8mnt_48", Ld = "_focusCenterRight_p8mnt_56", Rd = "_focusBottomLeft_p8mnt_60", Ad = "_focusBottomCenter_p8mnt_64", Hd = "_focusBottomRight_p8mnt_68", Fd = "_noOverlay_p8mnt_72", ne = {
  imageContainer: Od,
  overlay: Nd,
  focusTopLeft: Td,
  focusTopCenter: Sd,
  focusTopRight: Wd,
  focusCenterLeft: jd,
  focusCenter: zd,
  focusCenterRight: Ld,
  focusBottomLeft: Rd,
  focusBottomCenter: Ad,
  focusBottomRight: Hd,
  noOverlay: Fd
}, Lr = ({
  alt: t,
  focusArea: e = "CENTER",
  imageContainerClass: a = ne.imageContainer,
  imageOverlayClass: r = ne.overlay,
  showOverlay: n = !1,
  url: o
}) => /* @__PURE__ */ H("div", { "aria-label": t, className: `${a} ${((s) => ({
  BOTTOM_CENTER: ne.focusBottomCenter,
  BOTTOM_LEFT: ne.focusBottomLeft,
  BOTTOM_RIGHT: ne.focusBottomRight,
  CENTER: ne.focusCenter,
  CENTER_LEFT: ne.focusCenterLeft,
  CENTER_RIGHT: ne.focusCenterRight,
  TOP_CENTER: ne.focusTopCenter,
  TOP_LEFT: ne.focusTopLeft,
  TOP_RIGHT: ne.focusTopRight
})[s] || ne.focusCenter)(e)}`, "data-testid": "article-image", children: [
  /* @__PURE__ */ b("img", { alt: t || "background image", src: o }),
  /* @__PURE__ */ b("div", { className: `${r} ${n ? "" : ne.noOverlay}` })
] }), qd = "_lockBanner_pz94h_1", Id = {
  lockBanner: qd
};
function $d(t) {
  return /* @__PURE__ */ b(
    "svg",
    {
      fill: "none",
      height: "100%",
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 18 21",
      width: "18",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M9 12V14.25M0.75 8.25V19.5H17.25V8.25H0.75ZM3.75 8.25C3.75 3.75 3.75 0.75 9 0.75C14.25 0.75 14.25 3.75 14.25 8.25H3.75Z",
          stroke: "#00182E",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2"
        }
      )
    }
  );
}
const Yd = ({ isLoggedIn: t }) => /* @__PURE__ */ b("div", { className: Id.lockBanner, children: t ? /* @__PURE__ */ b("span", { "data-testid": "unlocked-header", children: "unlocked" }) : /* @__PURE__ */ H("span", { "data-testid": "locked-header", children: [
  /* @__PURE__ */ b($d, {}),
  "log in to view for free"
] }) });
function Bd(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(a) {
    return e[a] === void 0 && (e[a] = t(a)), e[a];
  };
}
var Xd = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, ot = /* @__PURE__ */ Bd(
  function(t) {
    return Xd.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Vd = function() {
  const e = Array.prototype.slice.call(arguments).filter(Boolean), a = {}, r = [];
  e.forEach((o) => {
    (o ? o.split(" ") : []).forEach((s) => {
      if (s.startsWith("atm_")) {
        const [, d] = s.split("_");
        a[d] = s;
      } else
        r.push(s);
    });
  });
  const n = [];
  for (const o in a)
    Object.prototype.hasOwnProperty.call(a, o) && n.push(a[o]);
  return n.push(...r), n.join(" ");
}, lr = Vd, Ud = (t) => t.toUpperCase() === t, Jd = (t) => (e) => t.indexOf(e) === -1, Rr = (t, e) => {
  const a = {};
  return Object.keys(t).filter(Jd(e)).forEach((r) => {
    a[r] = t[r];
  }), a;
};
function Qd(t, e, a) {
  const r = Rr(e, a);
  if (!t) {
    const n = typeof ot == "function" ? { default: ot } : ot;
    Object.keys(r).forEach((o) => {
      n.default(o) || delete r[o];
    });
  }
  return r;
}
var Zd = (t, e) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof t == "string" || // eslint-disable-next-line no-self-compare,no-restricted-globals
    typeof t == "number" && isFinite(t))
      return;
    const a = typeof t == "object" ? JSON.stringify(t) : String(t);
    console.warn(
      `An interpolation evaluated to '${a}' in the component '${e}', which is probably a mistake. You should explicitly cast or transform the value to a string.`
    );
  }
}, Gd = 0;
function ur(t) {
  let e = "";
  return process.env.NODE_ENV === "test" && (e += `mocked-styled-${Gd++}`, t && t.__wyw_meta && t.__wyw_meta.className && (e += ` ${t.__wyw_meta.className}`)), (a) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Array.isArray(a))
      throw new Error(
        'Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup'
      );
    const r = (o, i) => {
      const { as: s = t, class: d = e } = o, l = a.propsAsIs === void 0 ? !(typeof s == "string" && s.indexOf("-") === -1 && !Ud(s[0])) : a.propsAsIs, u = Qd(l, o, [
        "as",
        "class"
      ]);
      u.ref = i, u.className = a.atomic ? lr(a.class, u.className || d) : lr(u.className || d, a.class);
      const { vars: c } = a;
      if (c) {
        const p = {};
        for (const M in c) {
          const g = c[M], w = g[0], x = g[1] || "", h = typeof w == "function" ? w(o) : w;
          Zd(h, a.name), p[`--${M}`] = `${h}${x}`;
        }
        const f = u.style || {}, m = Object.keys(f);
        m.length > 0 && m.forEach((M) => {
          p[M] = f[M];
        }), u.style = p;
      }
      return t.__wyw_meta && t !== s ? (u.as = s, he(t, u)) : he(s, u);
    }, n = qa ? qa(r) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (o) => {
        const i = Rr(o, ["innerRef"]);
        return r(i, o.innerRef);
      }
    );
    return n.displayName = a.name, n.__wyw_meta = {
      className: a.class || e,
      extends: t
    }, n;
  };
}
var K = process.env.NODE_ENV !== "production" ? new Proxy(ur, {
  get(t, e) {
    return t(e);
  }
}) : ur;
const Kd = /* @__PURE__ */ K("a")({
  name: "Item",
  class: "Item_i1vcrbsf",
  propsAsIs: !1
}), el = /* @__PURE__ */ K("div")({
  name: "TitleContainer",
  class: "TitleContainer_t1dd2fjt",
  propsAsIs: !1
}), tl = "imageContainer_i1w8upjg", al = /* @__PURE__ */ K("div")({
  name: "Title",
  class: "Title_t1hmv483",
  propsAsIs: !1
}), Fa = /* @__PURE__ */ K("div")({
  name: "Author",
  class: "Author_a5c7qfj",
  propsAsIs: !1
}), rl = /* @__PURE__ */ K("div")({
  name: "FlexWrapper",
  class: "FlexWrapper_fr1f9kd",
  propsAsIs: !1
}), nl = () => Fa, ol = /* @__PURE__ */ K(nl())({
  name: "PublishedDate",
  class: "PublishedDate_p11oj3x9",
  propsAsIs: !0
}), il = () => Fa, sl = /* @__PURE__ */ K(il())({
  name: "ReadTime",
  class: "ReadTime_r1b6lu9v",
  propsAsIs: !0
}), dl = /* @__PURE__ */ K("p")({
  name: "Description",
  class: "Description_d1bzrkm8",
  propsAsIs: !1
}), ll = ({
  aiGeneratedId: t,
  authors: e = [],
  baseUrl: a,
  componentTags: r = [],
  description: n,
  image: o,
  isLoggedIn: i,
  publishedTime: s,
  readTime: d,
  repub: l,
  requestUrl: u,
  title: c,
  url: p
}) => {
  const f = () => {
    gr({
      aiArticle: t ? "yes" : "no",
      articleName: c,
      event: yr.ARTICLE_CLICK,
      tipsterName: e[0].fullName
    });
  }, m = jr(s, l), M = r.includes("TIPS_PREMIUM"), g = zr(p, l, a);
  return /* @__PURE__ */ H("div", { children: [
    M && /* @__PURE__ */ b(Yd, { isLoggedIn: i }),
    /* @__PURE__ */ H(Kd, { "data-testid": "article-item", href: He(g, u), onClick: f, children: [
      o && /* @__PURE__ */ b(
        Lr,
        {
          alt: o.alt,
          focusArea: o.focusArea,
          imageContainerClass: tl,
          url: br(o.url, 350)
        }
      ),
      /* @__PURE__ */ H(el, { children: [
        /* @__PURE__ */ b(al, { "data-testid": "article-title", children: c }),
        n && /* @__PURE__ */ b(dl, { "data-testid": "article-description", children: n }),
        /* @__PURE__ */ H(rl, { children: [
          /* @__PURE__ */ H("div", { children: [
            e.length && /* @__PURE__ */ b(Fa, { "data-testid": "article-author", children: e[0].fullName }),
            s && /* @__PURE__ */ b(ol, { "data-testid": "article-published-time", children: m })
          ] }),
          /* @__PURE__ */ b("div", { children: d && /* @__PURE__ */ b(sl, { "data-testid": "article-read-time", children: d }) })
        ] })
      ] })
    ] })
  ] });
}, ul = "_wrapper_1h6cv_3", cl = "_heroArticle_1h6cv_9", ml = "_imageContainer_1h6cv_21", fl = "_contentContainer_1h6cv_37", hl = "_overlay_1h6cv_48", vl = "_title_1h6cv_59", pl = "_metadata_1h6cv_68", gl = "_metadataLeft_1h6cv_75", yl = "_metadataRight_1h6cv_81", bl = "_mobileTimestamp_1h6cv_87", Ml = "_desktopTimestamp_1h6cv_96", wl = "_readTime_1h6cv_100", _l = "_mobileAuthor_1h6cv_110", Pl = "_desktopAuthor_1h6cv_119", te = {
  wrapper: ul,
  heroArticle: cl,
  imageContainer: ml,
  contentContainer: fl,
  overlay: hl,
  title: vl,
  metadata: pl,
  metadataLeft: gl,
  metadataRight: yl,
  mobileTimestamp: bl,
  desktopTimestamp: Ml,
  readTime: wl,
  mobileAuthor: _l,
  desktopAuthor: Pl
}, xl = ({
  authors: t = [],
  baseUrl: e,
  deviceType: a,
  image: r,
  publishedTime: n,
  readTime: o,
  repub: i,
  requestUrl: s,
  title: d,
  url: l
}) => {
  var g, w, x, h;
  const u = () => {
    gr({
      articleName: d,
      event: yr.HERO_ARTICLE_VIEW,
      tipsterName: t[0].fullName
    });
  }, c = jr(n, i), p = ((g = t[0]) == null ? void 0 : g.shortName) || ((w = t[0]) == null ? void 0 : w.fullName) || "", f = ((x = t[0]) == null ? void 0 : x.fullName) || ((h = t[0]) == null ? void 0 : h.shortName) || "", m = a === "MOBILE" ? 500 : a === "TABLET" ? 800 : 1e3, M = zr(l, i, e);
  return /* @__PURE__ */ b(
    "a",
    {
      className: te.wrapper,
      "data-testid": "hero-article",
      href: He(M, s),
      onClick: u,
      children: /* @__PURE__ */ H("div", { className: te.heroArticle, children: [
        /* @__PURE__ */ b(
          Lr,
          {
            alt: r.alt,
            focusArea: r.focusArea,
            imageContainerClass: te.imageContainer,
            imageOverlayClass: te.overlay,
            showOverlay: !0,
            url: br(r.url, m)
          }
        ),
        /* @__PURE__ */ H("div", { className: te.contentContainer, children: [
          /* @__PURE__ */ b("h2", { className: te.title, "data-testid": "hero-article-title", children: d }),
          /* @__PURE__ */ H("div", { className: te.metadata, children: [
            /* @__PURE__ */ H("div", { className: te.metadataLeft, children: [
              /* @__PURE__ */ b("div", { className: te.mobileAuthor, "data-testid": "hero-article-author-short-name", children: p }),
              /* @__PURE__ */ b("div", { className: te.desktopAuthor, "data-testid": "hero-article-author-full-name", children: f }),
              /* @__PURE__ */ b("div", { className: te.mobileTimestamp, "data-testid": "hero-article-publish-time", children: c })
            ] }),
            /* @__PURE__ */ H("div", { className: te.metadataRight, children: [
              /* @__PURE__ */ b("span", { className: te.desktopTimestamp, "data-testid": "hero-article-publish-time-read-time", children: `${c} | ${o}` }),
              /* @__PURE__ */ b("span", { className: te.readTime, "data-testid": "hero-article-read-time", children: o })
            ] })
          ] })
        ] })
      ] })
    }
  );
};
function Ar(t) {
  var e, a, r = "";
  if (typeof t == "string" || typeof t == "number")
    r += t;
  else if (typeof t == "object")
    if (Array.isArray(t)) {
      var n = t.length;
      for (e = 0; e < n; e++)
        t[e] && (a = Ar(t[e])) && (r && (r += " "), r += a);
    } else
      for (a in t)
        t[a] && (r && (r += " "), r += a);
  return r;
}
function El() {
  for (var t, e, a = 0, r = "", n = arguments.length; a < n; a++)
    (t = arguments[a]) && (e = Ar(t)) && (r && (r += " "), r += e);
  return r;
}
const kl = "_up_77ag3_1", Cl = "_down_77ag3_6", Dl = "_right_77ag3_11", Ol = "_left_77ag3_16", Nl = "_md_77ag3_21", Tl = "_sm_77ag3_26", Sl = "_loading_77ag3_31", Wl = "_light_77ag3_39", jl = "_dark_77ag3_42", cr = {
  up: kl,
  down: Cl,
  right: Dl,
  left: Ol,
  md: Nl,
  sm: Tl,
  loading: Sl,
  light: Wl,
  dark: jl
}, zl = ({ variant: t }) => /* @__PURE__ */ b("span", { className: El(cr.loading, cr[t]), children: "" });
const Ll = "pageLink_p5rg824", Rl = "paginationBreak_pqpdg5d", Al = "paginationBreakLink_p3x7g4w", Hl = "activePageLink_a1q216p", Fl = /* @__PURE__ */ K("div")({
  name: "Container",
  class: "Container_c1bvwa30",
  propsAsIs: !1
}), ql = /* @__PURE__ */ K("div")({
  name: "Header",
  class: "Header_hq2cit",
  propsAsIs: !1
}), Il = () => ({
  isHref: t
}) => t ? "underline" : "none", $l = /* @__PURE__ */ K("a")({
  name: "HeadingLink",
  class: "HeadingLink_hhcy2b8",
  propsAsIs: !1,
  vars: {
    "hhcy2b8-0": [Il()]
  }
}), Yl = () => ({
  isCentered: t
}) => t ? "center" : "flex-start", Bl = /* @__PURE__ */ K("div")({
  name: "Footer",
  class: "Footer_fjszzm6",
  propsAsIs: !1,
  vars: {
    "fjszzm6-0": [Yl()]
  }
}), Xl = () => ({
  rows: t
}) => `repeat(${t}, auto)`, Vl = /* @__PURE__ */ K("div")({
  name: "ItemsContainer",
  class: "ItemsContainer_i16u1jk6",
  propsAsIs: !1,
  vars: {
    "i16u1jk6-0": [Xl()]
  }
}), Ul = /* @__PURE__ */ K("a")({
  name: "ArrowLink",
  class: "ArrowLink_a1ez9tjb",
  propsAsIs: !1
}), Jl = /* @__PURE__ */ K("button")({
  name: "LoadMoreButtonLink",
  class: "LoadMoreButtonLink_l79kqg5",
  propsAsIs: !1
}), Ql = {
  FIRST_ARTICLE: "FIRST_ARTICLE",
  NONE: "NONE"
}, Zl = ({
  articles: t,
  articlesPage: e,
  baseUrl: a,
  defaultFeaturedArticle: r,
  deviceType: n,
  featuredArticleId: o,
  hasNextPage: i,
  isLoading: s,
  isLoggedIn: d,
  limit: l,
  loadMoreArticles: u,
  moreArticlesPath: c,
  moreArticlesText: p = "More Picks",
  pagination: f,
  paginationNextLabel: m,
  paginationPrevLabel: M,
  repub: g,
  requestUrl: w,
  title: x,
  total: h,
  type: y
}) => {
  const D = "oddschecker", R = Math.ceil(h / (l ?? 10)), $ = (_) => {
    const N = _.selected + 1, T = new URL(window.location.href);
    N === 1 ? T.searchParams.delete("articlesPage") : T.searchParams.set("articlesPage", N.toString()), window.location.href = He(T.toString());
  }, F = t.find((_) => _.id === o) || (r === Ql.FIRST_ARTICLE ? t[0] : null), ze = F ? t.filter((_) => _.id !== F.id) : t, Je = () => c ? /* @__PURE__ */ H(Ul, { "data-testid": "more-articles-link", href: He(c, w), children: [
    p,
    /* @__PURE__ */ b("svg", { fill: "none", height: "10", viewBox: "0 0 11 10", width: "11", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ b(
      "path",
      {
        d: "M4.00003 0.757359L8.24267 5L4.00003 9.24264",
        stroke: "var(--cxy-color-interactive-secondary-subtle)",
        strokeWidth: "1.5"
      }
    ) })
  ] }) : null, E = () => i ? /* @__PURE__ */ b(Jl, { "data-testid": "more-articles-link", disabled: s, onClick: u, children: s ? /* @__PURE__ */ b(zl, { variant: "light" }) : p }) : null;
  return /* @__PURE__ */ H(Fl, { "data-fpsm-theme": D, "data-testid": "more-articles", children: [
    F && /* @__PURE__ */ b(xl, { ...F, baseUrl: a, deviceType: n, repub: g, requestUrl: w }),
    x && /* @__PURE__ */ b(ql, { children: /* @__PURE__ */ b(
      $l,
      {
        "data-testid": "more-articles-title",
        href: c ? He(c, w) : void 0,
        isHref: !!c,
        title: x,
        children: x
      }
    ) }),
    /* @__PURE__ */ b(Vl, { rows: t.length, children: ze.map((_) => /* @__PURE__ */ he(
      ll,
      {
        ..._,
        articleType: y,
        baseUrl: a,
        isLoggedIn: d,
        key: _.id,
        repub: g,
        requestUrl: w
      }
    )) }),
    f !== "NO_PAGINATION" && /* @__PURE__ */ H(Bl, { isCentered: !c, children: [
      f === "BOTTOM_PAGE_NUMBERS" && R > 1 && /* @__PURE__ */ b(
        so,
        {
          activeLinkClassName: Hl,
          breakClassName: Rl,
          breakLabel: "...",
          breakLinkClassName: Al,
          forcePage: e - 1,
          hrefAllControls: !0,
          hrefBuilder: (_, N, T) => {
            if (_ < 1 || _ === T + 1)
              return;
            if (_ === 1) {
              if (typeof window < "u") {
                const P = new URL(window.location.href);
                P.searchParams.delete("articlesPage");
                const v = P.searchParams.toString();
                return v ? `${P.pathname}?${v}` : P.pathname;
              }
              const B = new URL(w);
              B.searchParams.delete("articlesPage");
              const ee = B.searchParams.toString();
              return ee ? `${B.pathname}?${ee}` : B.pathname;
            }
            if (typeof window < "u") {
              const B = new URL(window.location.href);
              return B.searchParams.set("articlesPage", String(_)), `${B.pathname}?${B.searchParams.toString()}`;
            }
            const se = new URL(w);
            return se.searchParams.set("articlesPage", String(_)), `${se.pathname}?${se.searchParams.toString()}`;
          },
          marginPagesDisplayed: 1,
          nextLabel: m,
          onPageChange: $,
          pageCount: R,
          pageLinkClassName: Ll,
          pageRangeDisplayed: 1,
          previousLabel: M,
          selectedPageRel: null
        }
      ),
      f === "MORE_ARTICLES_LINKS" && c && /* @__PURE__ */ b(Je, {}),
      f === "LOAD_MORE_BUTTON" && /* @__PURE__ */ b(E, {})
    ] })
  ] });
}, Gl = ({
  articlesPage: t,
  dataApiEndpoint: e,
  defaultFeaturedArticle: a,
  deviceType: r,
  featuredArticleId: n,
  isLoggedIn: o,
  moreArticlesPath: i,
  moreArticlesText: s,
  title: d,
  ...l
}) => {
  const [u, c] = mr(100), p = Number.isFinite(t) && t > 0 ? t : 1, f = wr(l), { data: m, fetchNextPage: M, hasNextPage: g, isFetchingNextPage: w } = Ur({
    getNextPageParam(y, D) {
      if (!(!y || y.length < l.limit))
        return D.length;
    },
    initialPageParam: p - 1,
    queryFn: async ({ pageParam: y }) => {
      const D = await Mr(
        e,
        {
          ...l,
          offset: y * l.limit
        },
        {
          logger: console
        }
      );
      return D ? (c(D.total), D.articles) : [];
    },
    queryKey: f,
    refetchOnMount: l.pagination === "BOTTOM_PAGE_NUMBERS" ? "always" : !1
    // this is to ensure that we get the articles total
  });
  if (!m || m.pages.flat().length === 0)
    return null;
  const h = m.pages.flat().filter((y) => y !== null);
  return /* @__PURE__ */ b(
    Zl,
    {
      articles: h,
      articlesPage: p,
      baseUrl: l.baseUrl,
      defaultFeaturedArticle: a,
      deviceType: r,
      featuredArticleId: n,
      hasNextPage: g,
      isLoading: w,
      isLoggedIn: o,
      limit: l.limit,
      loadMoreArticles: M,
      moreArticlesPath: i,
      moreArticlesText: s,
      offset: l.offset,
      pagination: l.pagination,
      repub: l.repub,
      requestUrl: l.requestUrl,
      title: d,
      total: u,
      type: l.type
    }
  );
};
var Kl = /* @__PURE__ */ ((t) => (t.Insights = "INSIGHTS", t.Tips = "TIPS", t))(Kl || {});
function eu(t = {}) {
  var e;
  return new Vr.QueryClient({
    ...t,
    defaultOptions: {
      ...t.defaultOptions,
      queries: {
        retry: 3,
        retryDelay(a) {
          return a * 100;
        },
        ...(e = t.defaultOptions) == null ? void 0 : e.queries
      }
    }
  });
}
const lu = async (t, e) => {
  const a = eu(), r = Number.isFinite(t.articlesPage) && t.articlesPage > 0 ? t.articlesPage : 1, n = Math.max(0, (r - 1) * t.limit);
  let o = 0;
  try {
    const l = {
      countryCode: t.countryCode,
      limit: t.limit,
      offset: n,
      pagination: t.pagination,
      repub: t.repub,
      requestUrl: t.requestUrl,
      subdivision: t.subdivision,
      topics: t.topics,
      type: t.type
    };
    await a.prefetchInfiniteQuery({
      getNextPageParam(u, c) {
        if (!(!u || u.length < t.limit))
          return c.length;
      },
      initialPageParam: r - 1,
      queryFn: async ({ pageParam: u = 0 }) => {
        const c = await Mr(
          e,
          {
            ...l,
            offset: u * t.limit
          },
          { nocache: t.nocache }
        );
        return c && (o = c.total), c.articles;
      },
      queryKey: wr(l),
      staleTime: 1 / 0
    });
  } catch {
  }
  const i = Jr(a), s = Math.ceil(o / t.limit), d = {
    articlesPerPage: t.limit,
    currentPage: r,
    hasNextPage: r < s,
    hasPrevPage: r > 1,
    totalArticles: o,
    totalPages: s
  };
  return {
    dehydratedState: i,
    paginationMeta: d
  };
}, tu = (t) => new Kr({
  defaultOptions: {
    queries: {
      gcTime: t ? 0 : void 0,
      refetchOnMount: !!t,
      retry: (e, a) => {
        var r;
        return ((r = a == null ? void 0 : a.response) == null ? void 0 : r.status) === 404 ? !1 : e < 2;
      },
      retryDelay: (e) => Math.min(1e3 * (e + 1), 3e3),
      staleTime: t ? 0 : 1 / 0
    }
  }
}), au = ({ resetErrorBoundary: t }) => (Xr(() => {
  t();
}, [t]), null);
function uu({ dehydratedState: t, nocache: e, ...a }) {
  const [r] = mr(() => {
    const n = tu(e);
    return Qr(n, t), n;
  });
  return /* @__PURE__ */ b(mn, { children: /* @__PURE__ */ b(Zr, { client: r, children: /* @__PURE__ */ b(Gr, { children: ({ reset: n }) => /* @__PURE__ */ b(
    rn,
    {
      fallbackRender: ({ resetErrorBoundary: o }) => /* @__PURE__ */ b(au, { resetErrorBoundary: o }),
      onReset: n,
      children: /* @__PURE__ */ b(fn, { i18nInstance: a.i18n, children: /* @__PURE__ */ b(Br, { fallback: /* @__PURE__ */ b(vn, {}), children: /* @__PURE__ */ b(Gl, { ...a }) }) })
    }
  ) }) }) });
}
export {
  Kl as ArticleTypes,
  uu as MoreArticlesWithQuery,
  lu as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
